<template>
  <div class="box-detail">
    <div class="box-left">
      <div class="box-left-header-contact">
        <div
          v-if="(formData.exts.contactType = 2)"
          @click="$router.push({ path: '/ContactFixs' })"
          class="goBack"
        >
          <i class="el-icon-arrow-left"></i>
          <span>客户</span>
          <i class="el-icon-s-custom"></i>
        </div>

        <div v-else @click="$router.push({ path: '/Contacts' })" class="goBack">
          <i class="el-icon-arrow-left"></i>
          <span>客户</span>
          <i class="el-icon-s-custom"></i>
        </div>
        <div class="profile-info">
          <el-image
            style="width: 72px; height: 72px; border-radius: 50%"
            src="https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg"
            fit="cover"
          ></el-image>
          <span>{{ formData.name }}</span>
          <ul class="shortcuts">
            <li v-if="serviceState">
              <el-popconfirm
                confirmButtonText="呼出"
                cancelButtonText="取消"
                icon="el-icon-phone"
                iconColor="#409EFF"
                hideIcon
                :title="formData.name + ' ' + formData.phone"
                @confirm="
                  osg.sobot.selfCallOut(
                    {
                      callNum: formData.phone,
                      bizType: 'Contacts',
                      bizId: formData._id
                    },
                    callOutBack
                  )
                "
                popper-class="c-popconfirm"
              >
                <el-button
                  icon="el-icon-phone f-bold"
                  circle
                  slot="reference"
                  type="primary"
                  class="c-btn-callout"
                ></el-button>
              </el-popconfirm>
              <span>外呼</span>
            </li>
            <li v-else>
              <el-tooltip
                class="item"
                effect="dark"
                content="外呼"
                placement="top"
                :open-delay="300"
              >
                <a :href="'tel:' + formData.phone">
                  <el-button icon="el-icon-phone f-bold" circle></el-button>
                </a>
              </el-tooltip>
              <span>外呼</span>
            </li>
            <li
              v-if="
                serviceState &&
                  (tenantId == '1340835581184723420' || tenantId == '4551453470943235290')
              "
            >
              <el-popover
                iconColor="#409EFF"
                hideIcon
                width="400"
                v-model="openMessages"
                :title="formData.name + ' ' + formData.phone"
                popper-class="c-popconfirm"
              >
                <div>
                  <el-input
                    v-model="messagesContent"
                    type="textarea"
                    placeholder="请输入要发送的短信"
                    maxlength="100"
                    show-word-limit
                    :autosize="{
                      minRows: 4,
                      maxRows: 2
                    }"
                  ></el-input>
                </div>
                <div class="c-m-t-10" style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="openMessages = false">取消</el-button>
                  <el-button type="primary" size="mini" @click="sendMessages">发送短信</el-button>
                </div>
                <el-button
                  slot="reference"
                  icon="el-icon-message f-bold"
                  circle
                  type="primary"
                  class="c-btn-callout"
                ></el-button>
              </el-popover>
              <span>短信</span>
            </li>
            <!-- <li>
              <el-tooltip
                class="item"
                effect="dark"
                content="创建笔记"
                placement="top"
                :open-delay="300"
              >
                <el-button
                  icon="el-icon-edit-outline f-bold"
                  circle
                  @click="
                    activeTab = 'notes';
                    openNote = true;
                  "
                ></el-button>
              </el-tooltip>
              <span>笔记</span>
            </li> -->
          </ul>
        </div>
      </div>
      <div class="box-left-content">
        <c-form
          :formData="formData"
          :fields="extFields"
          :area="area"
          :options="options"
          ref="form"
          :labelPosition="'top'"
          @changeForm="osg.changeForm"
        >
          <!-- <template slot="contactType"> -->
          <el-form-item label="客户类型" prop="contactType">
            <el-select v-model="formData.exts.contactType" clearable>
              <el-option
                v-for="item in options.contactType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- </template> -->

          <!-- <template slot="address">
            <el-input
              v-model="formData.address"
              suffix-icon="el-icon-map-location"
              @blur="osg.getGeocode()"
            ></el-input>
          </template> -->
        </c-form>
      </div>
      <div class="box-left-footer">
        <el-button type="primary" @click="doSave">提交</el-button>
        <el-button plain @click="getData">取消</el-button>
      </div>
    </div>
    <div class="c-flex c_flex_col c-w-1 c_flex_1" style="overflow:hidden">
      <phoneStrip
        style="
          position: fixed;
          top: 0;
          width: 70vw;
          z-index: 4000;
          transform: translateX(-50%);
          left: 50%;
        "
        :profileTheme="profileTheme"
        :phoneStripData="{
          bizId: formData._id,
          bizType: 'contacts',
          callId: callId,
          caller: formData.phone,
          formData,
          storagetransfer
        }"
        v-if="serviceState && record.openRecord && callId && formData.phone"
        @phoneStripFn="phoneStripFn"
      ></phoneStrip>
      <div class="box-detail" style="flex: 1">
        <div class="box-center">
          <el-tabs v-model="activeTab" @tab-click="tabClick" class="c-h-1 c-flex c-flex-col">
            <el-tab-pane label="已购买存货" name="purchase" v-if="osg.has('Contacts,purchase')">
              <div class="c_flex c_flex_between">
                <el-date-picker
                  v-model="purchase.searchDate"
                  type="daterange"
                  start-placeholder="安装日期"
                  end-placeholder="安装日期"
                  value-format="yyyy-MM-dd"
                  clearable
                  @change="purchaseQuery"
                  class="search-date"
                ></el-date-picker>
                <el-input
                  placeholder="存货名称/规格型号/安装地址/工单编号"
                  v-model="purchase.searchValue"
                  class="search-input c-m-l-10"
                  style="width:320px"
                  clearable
                  @clear="purchaseQuery"
                  @keyup.enter.native="purchaseQuery"
                >
                  <el-button slot="append" icon="el-icon-search" @click="purchaseQuery"></el-button>
                </el-input>
              </div>
              <div class="c_flex" style="flex-direction: row-reverse;margin:15px 0;">
                <el-button type="primary" class="c-m-l-10" @click="SANew">
                  创建工单
                </el-button>
                <el-button type="primary" class="c-m-l-10" @click="purchaseNew">
                  添加已购买存货
                </el-button>
              </div>
              <div class="box-center-content" style="padding-bottom:0">
                <el-table
                  ref="purchase"
                  height="calc(100% - 50px)"
                  :data="purchase.fpi.data"
                  highlight-current-row
                  border
                  @selection-change="purchaseSelectChange"
                  row-key="_id"
                >
                  <el-table-column
                    type="selection"
                    width="50"
                    fixed
                    :reserve-selection="true"
                  ></el-table-column>
                  <c-table :fields="purchase.extFields"></c-table>
                  <el-table-column
                    fixed="right"
                    label="操作"
                    width="100px"
                    v-if="osg.has('Contacts,purchaseEdit') || osg.has('Contacts,purchaseRemove')"
                  >
                    <template slot-scope="scope">
                      <el-dropdown>
                        <el-button>
                          操作
                          <i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item
                            @click.native="purchaseEdit(scope.row)"
                            v-if="osg.has('Contacts,purchaseEdit')"
                          >
                            编辑
                          </el-dropdown-item>
                          <el-dropdown-item
                            @click.native="purchaseRemove(scope.row._id)"
                            v-if="osg.has('Contacts,purchaseRemove')"
                          >
                            删除
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  class="pagination"
                  @size-change="pageSizeChange"
                  @current-change="pageChange"
                  :current-page="purchase.fpi.page"
                  :page-sizes="[10, 20, 50, 100]"
                  :page-size="purchase.fpi.rows"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="purchase.fpi.total"
                ></el-pagination>
                <el-dialog
                  title="已购买存货"
                  :visible.sync="purchase.open"
                  :close-on-click-modal="false"
                  :close-on-press-escape="false"
                >
                  <c-form
                    labelWidth="110px"
                    :formData="purchase.formData"
                    :fields="purchase.extFields"
                    :area="area"
                    :upload="upload"
                    :options="options"
                    ref="purchaseFormData"
                    @changeForm="osg.changeForm"
                  ></c-form>
                  <div slot="footer">
                    <el-button type="primary" @click="purchaseSave">保存</el-button>
                    <el-button @click="purchase.open = false">
                      取 消
                    </el-button>
                    <!-- <el-button type="primary" @click="doSave">确 定</el-button> -->
                  </div>
                </el-dialog>
                <el-dialog
                  title="创建工单"
                  :visible.sync="SA.open"
                  :close-on-click-modal="false"
                  :close-on-press-escape="false"
                >
                  <c-form
                    labelWidth="110px"
                    :formData="SA.formData"
                    :fields="SA.extFields"
                    :area="area"
                    :upload="upload"
                    :options="options"
                    ref="SAFormData"
                    @changeForm="osg.changeForm"
                  ></c-form>
                  <div slot="footer">
                    <el-button type="primary" @click="SASave">保存</el-button>
                    <el-button @click="SA.open = false">
                      取 消
                    </el-button>
                  </div>
                </el-dialog>
              </div>
            </el-tab-pane>
            <el-tab-pane
              label="工单"
              name="serviceAppointment"
              v-if="osg.has('Contacts,serviceAppointment')"
            >
              <div class="c_flex c_flex_between">
                <div></div>
                <el-input
                  placeholder="工单编号/标题/姓名/手机/地址"
                  v-model="serviceAppointment.searchValue"
                  class="search-input c-m-l-10"
                  style="width:320px"
                  clearable
                  @clear="
                    serviceAppointment.fpi.page = 1;
                    getServiceAppointments();
                  "
                  @keyup.enter.native="
                    serviceAppointment.fpi.page = 1;
                    getServiceAppointments();
                  "
                >
                  <el-button
                    slot="append"
                    icon="el-icon-search"
                    @click="
                      serviceAppointment.fpi.page = 1;
                      getServiceAppointments();
                    "
                  ></el-button>
                </el-input>
              </div>
              <div class="box-center-content" style="margin-top:15px;padding-bottom:0;">
                <el-table
                  ref="serviceAppointment"
                  height="calc(100% - 50px)"
                  :data="serviceAppointment.fpi.data"
                  highlight-current-row
                  border
                >
                  <c-table :fields="serviceAppointment.extFields"></c-table>
                </el-table>
                <el-pagination
                  class="pagination"
                  @size-change="pageSizeChange"
                  @current-change="pageChange"
                  :current-page="serviceAppointment.fpi.page"
                  :page-sizes="[10, 20, 50, 100]"
                  :page-size="serviceAppointment.fpi.rows"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="serviceAppointment.fpi.total"
                ></el-pagination>
              </div>
            </el-tab-pane>
            <el-tab-pane label="业务动态" name="log">
              <div class="box-center-tool">
                <div>
                  <el-date-picker
                    v-model="log.searchDate"
                    type="datetimerange"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-time="['00:00:00', '23:59:59']"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    clearable
                    @change="getLog"
                    class="search-date"
                  ></el-date-picker>
                </div>
                <div>
                  <el-input
                    placeholder="请输入标题/内容"
                    v-model="log.searchValue"
                    class="search-input"
                    clearable
                    @clear="getLog"
                    @keyup.enter.native="getLog"
                  >
                    <el-button slot="append" icon="el-icon-search" @click="getLog"></el-button>
                  </el-input>
                </div>
              </div>
              <div class="box-center-content">
                <div class="activity-card" v-for="(log, i) in log.fpi.data" :key="i">
                  <div class="activity-card-header">
                    <span class="c-font-500">
                      <i class="el-icon-monitor c-w-30"></i>
                      {{ log.title }}
                    </span>
                    <span>{{ log.createTime }}</span>
                  </div>
                  <div class="activity-card-content">
                    {{ log.content }}
                  </div>
                  <div class="activity-card-footer">
                    <span>操作人：{{ log.createUserName }}</span>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="笔记" name="notes" v-if="false">
              <div class="box-center-tool">
                <div></div>
                <el-button
                  type="primary"
                  size="mini"
                  @click="
                    vqeditor.content = ``;
                    openNote = true;
                  "
                >
                  创建笔记
                </el-button>
              </div>
              <div class="box-center-content">
                <div class="activity-card" v-for="(note, i) in noteData" :key="i">
                  <div class="activity-card-header">
                    <span>
                      <i class="el-icon-edit-outline c-w-30"></i>
                      笔记
                    </span>
                    <span>{{ note.createTime }}</span>
                  </div>
                  <div
                    class="activity-card-content-node"
                    v-html="note.content"
                    v-if="!note.openNote"
                  ></div>
                  <c-editor
                    v-else
                    class="c-m-15"
                    :formData="note"
                    :value="'content'"
                    ref="editor"
                  ></c-editor>
                  <div class="activity-card-footer">
                    <span>操作人：{{ note.createUserName }}</span>
                  </div>
                </div>
              </div>
              <!-- markdown编辑器 -->
              <el-dialog
                title="笔记"
                :visible.sync="openNote"
                @close="vqeditor.content = ''"
                :close-on-click-modal="false"
                :close-on-press-escape="false"
              >
                <c-editor :formData="vqeditor" :value="'content'" ref="editor"></c-editor>
                <div slot="footer">
                  <el-button type="primary" @click="saveNote">确 认</el-button>
                  <el-button
                    @click="
                      openNote = false;
                      vqeditor.content = '';
                    "
                  >
                    取 消
                  </el-button>
                </div>
              </el-dialog>
            </el-tab-pane>
            <el-tab-pane
              :label="tenantId == '1340835581184723420' ? '跟进/建单' : '跟进记录'"
              name="record"
            >
              <div class="box-center-tool">
                <div></div>
                <el-button type="primary" size="mini" @click="openRecordFun">创建</el-button>
              </div>
              <div class="box-center-content">
                <template>
                  <div class="activity-card" v-for="(reco, i) in record.fpi.data" :key="i">
                    <div class="activity-card-header">
                      <span>
                        <i class="el-icon-edit-outline c-w-30"></i>
                        跟进记录
                      </span>
                      <span>{{ reco.createTime }}</span>
                    </div>
                    <div class="activity-card-content">
                      <div class="c-flex" v-if="reco.serviceAppointmentOrderNum">
                        工单编号：
                        <el-link
                          @click="
                            osg.open(
                              '',
                              '',
                              '_blank',
                              '/ServiceAppointment/' + reco.serviceAppointmentId
                            )
                          "
                          target="_blank"
                        >
                          {{ reco.serviceAppointmentOrderNum }}
                        </el-link>
                      </div>
                      <div class="c-flex" v-if="reco.dedicateMode">
                        <span>通话状态：</span>
                        <span
                          v-text="
                            formatterCodelabel(
                              Array.isArray(reco.dedicateMode)
                                ? reco.dedicateMode.join(',')
                                : reco.dedicateMode,
                              'LEADSTATUS',
                              'cascade'
                            )
                          "
                        ></span>
                      </div>
                      <div v-if="reco.nextTime">下次联系时间： {{ reco.nextTime }}</div>
                      <div v-if="reco.name">
                        <span>姓名：</span>
                        <span>{{ reco.name }}</span>
                      </div>
                      <div v-if="reco.phone">
                        <span>手机号：</span>
                        <span>{{ reco.phone }}</span>
                      </div>
                      <div v-if="reco.province">
                        <span>省：</span>
                        <span>{{ formatProvince(reco.province) || '' }}</span>
                      </div>
                      <div v-if="reco.city">
                        <span>市：</span>
                        <span>{{ formatCity(reco.city) || '' }}</span>
                      </div>
                      <div v-if="reco.district">
                        <span>区：</span>
                        <span>{{ formatDistrict(reco.district) || '' }}</span>
                      </div>
                      <div v-if="reco.address">
                        <span>地址：</span>
                        <span>{{ reco.address }}</span>
                      </div>
                      <div v-if="reco.channel">
                        <span>信息渠道：</span>
                        <span
                          v-text="
                            osg.formatCascade(
                              'channel',
                              osg.isJson(reco.channel) ? JSON.parse(reco.channel) : reco.channel
                            )
                          "
                        ></span>
                      </div>
                      <div v-if="reco.leakagesite">
                        <span>维修部位：</span>
                        <span
                          v-text="
                            osg.formatCascadeMultiple(
                              'repairParts',
                              osg.isJson(reco.leakagesite)
                                ? JSON.parse(reco.leakagesite)
                                : reco.leakagesite
                            )
                          "
                        ></span>
                      </div>
                      <div v-if="reco.memo" style="line-height: 34px">备注： {{ reco.memo }}</div>

                      <div v-for="(FUitem, j) in followingUpNoteExtFields" :key="j">
                        <div v-if="reco.exts[FUitem.name]">
                          <span>{{ FUitem.nameDisp }}：</span>
                          <span
                            v-text="formatFieldValue(reco, FUitem, reco.exts[FUitem.name])"
                          ></span>
                        </div>
                      </div>
                    </div>
                    <div class="activity-card-footer">
                      <span>操作人：{{ reco.createUserName }}</span>
                      <el-button
                        v-if="reco.callId"
                        icon="el-icon-view"
                        size="mini"
                        @click="viewCallRecord(reco.callId)"
                      >
                        查看通话记录
                      </el-button>
                    </div>
                  </div>
                </template>
                <!-- <div class="activity-card">
                  <el-table :data="record.fpi.data" style="width: 100%">
                    <c-table :fields="followingUpNoteExtFields"></c-table>
                  </el-table>
                </div> -->
              </div>
              <el-dialog
                title="通话记录"
                id="callRecordDialog"
                :visible.sync="record.openCallRecord"
                @close="record.callData = {}"
                :close-on-click-modal="false"
                :close-on-press-escape="false"
              >
                <div class="box-center-content" style="border: 1px solid #ccc; border-radius: 6px">
                  <!-- v-for="(item, i) in record.callData" :key="i" -->
                  <div class="activity-card">
                    <div class="activity-card-header">
                      <span class="c-font-500">
                        <i class="el-icon-phone-outline c-w-30"></i>
                        <span v-if="record.callData.callDirection == '0'">呼入</span>
                        <span v-else-if="record.callData.callDirection == '1'">呼出</span>
                      </span>
                      <span v-if="record.callData.callWay == 4">
                        {{ formatMiddleCallResult(record.callData.middleCallResult) }}
                      </span>
                      <span v-else>{{ formatCallResult(record.callData.callResult) }}</span>
                    </div>
                    <div class="activity-card-content">
                      <div>
                        主叫：{{ record.callData.callerName }}
                        {{ record.callData.caller }}
                      </div>
                      <div>
                        被叫：{{
                          record.callData.callWay == 4
                            ? record.callData.calleeName || ''
                            : record.callData.callDirection == '0'
                            ? record.callData.calleeName || ''
                            : record.callData.calleeName || formData.name || ''
                        }}{{ ' ' + record.callData.callee }}
                      </div>
                      <div>
                        通话时间：{{ record.callData.startTimeStr }} 至
                        {{ record.callData.endTimeStr }}
                      </div>
                      <audio
                        v-if="record.callData.recordUrl"
                        class="c-m-t-15 w-1"
                        controls
                        :src="record.callData.recordUrl"
                        :controlsList="osg.has('Contact,downloadAudio') ? null : 'nodownload'"
                        @contextmenu.prevent="osg.has('Contact,downloadAudio') ? true : ''"
                      >
                        您的浏览器不支持 audio 标签。
                      </audio>
                    </div>
                    <div class="activity-card-footer">
                      <!-- <span>操作人：{{ item.createUserName }}</span> -->
                      <span></span>
                      <span>生成记录时间：{{ record.callData.createTime }}</span>
                    </div>
                  </div>
                </div>
                <div slot="footer">
                  <el-button
                    @click="
                      record.openCallRecord = false;
                      record.callData = {};
                    "
                  >
                    关闭
                  </el-button>
                </div>
              </el-dialog>
            </el-tab-pane>
            <el-tab-pane label="通话记录" name="callRecords">
              <div class="box-center-tool">
                <div>
                  <el-date-picker
                    v-model="callRecords.searchDate"
                    type="datetimerange"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-time="['00:00:00', '23:59:59']"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    clearable
                    @change="getCallRecords"
                    class="search-date"
                  ></el-date-picker>
                </div>
                <div>
                  <el-input
                    placeholder="请输入主叫/被叫号码"
                    v-model="callRecords.searchValue"
                    class="search-input"
                    clearable
                    @clear="getCallRecords"
                    @keyup.enter.native="getCallRecords"
                  >
                    <el-button
                      slot="append"
                      icon="el-icon-search"
                      @click="getCallRecords"
                    ></el-button>
                  </el-input>
                </div>
              </div>
              <div class="box-center-content">
                <div class="activity-card" v-for="(item, i) in callRecords.fpi.data" :key="i">
                  <div class="activity-card-header">
                    <span class="c-font-500">
                      <i class="el-icon-phone-outline c-w-30"></i>
                      <span v-if="item.callDirection == '0'">呼入</span>
                      <span v-else-if="item.callDirection == '1'">呼出</span>
                    </span>
                    <span>{{ formatCallResult(item.callResult) }}</span>
                  </div>
                  <div class="activity-card-content">
                    <div>
                      主叫：{{ item.callerName }}
                      {{ item.caller }}
                    </div>
                    <div>
                      被叫：{{
                        item.callWay == 4
                          ? item.calleeName || ''
                          : item.callDirection == '0'
                          ? item.calleeName || ''
                          : item.calleeName || formData.name || ''
                      }}{{ ' ' + item.callee }}
                    </div>
                    <div>
                      通话时间：{{ item.startTimeStr }} 至
                      {{ item.endTimeStr }}
                    </div>
                    <audio
                      v-if="item.recordUrl"
                      class="c-m-t-15"
                      :controlsList="osg.has('Contact,downloadAudio') ? null : 'nodownload'"
                      @contextmenu.prevent="osg.has('Contact,downloadAudio') ? true : ''"
                      controls
                      :src="item.recordUrl"
                    >
                      您的浏览器不支持 audio 标签。
                    </audio>
                  </div>
                  <div class="activity-card-footer">
                    <!-- <span>操作人：{{ item.createUserName }}</span> -->
                    <span></span>
                    <span>生成记录时间：{{ item.createTime }}</span>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="udesk通话记录" name="UDcallRecords">
              <!-- <div class="box-center-tool">
              <div>
                <el-date-picker
                  v-model="UDcallRecords.searchDate"
                  type="datetimerange"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :default-time="['00:00:00', '23:59:59']"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  clearable
                  @change="getUDcallRecords"
                  class="search-date"
                ></el-date-picker>
              </div>
              <div>
                <el-input
                  placeholder="请输入主叫/被叫号码"
                  v-model="UDcallRecords.searchValue"
                  class="search-input"
                  clearable
                  @clear="getUDcallRecords"
                  @keyup.enter.native="getUDcallRecords"
                >
                  <el-button
                    slot="append"
                    icon="el-icon-search"
                    @click="getUDcallRecords"
                  ></el-button>
                </el-input>
              </div>
            </div> -->
              <div class="box-center-content">
                <div class="activity-card" v-for="(item, i) in UDcallRecords.fpi.data" :key="i">
                  <div class="activity-card-header">
                    <span class="c-font-500">
                      <i class="el-icon-phone-outline c-w-30"></i>
                      <span>{{ item.call_type }}</span>
                      <!-- <span v-if="item.callDirection == '0'">呼入</span>
                    <span v-else-if="item.callDirection == '1'">呼出</span> -->
                    </span>
                    <!-- <span v-if="item.callWay == 4">
                    {{ formatMiddleCallResult(item.callResult) }}
                  </span>
                  <span v-else>{{ formatCallResult(item.callResult) }}</span> -->
                  </div>
                  <div class="activity-card-content">
                    <!-- <div>主叫：{{ item.callerName }} {{ item.caller }}</div>
                  <div>
                    被叫：{{
                      item.callWay == 4
                        ? item.calleeName || ''
                        : item.callDirection == '0'
                        ? item.calleeName || ''
                        : item.calleeName || formData.name || ''
                    }}{{ ' ' + (item.callee || '') }}
                  </div> -->
                    <dir>客服姓名：{{ item.agent_name }}</dir>
                    <div>通话时间：{{ item.start_time }} 至 {{ item.end_time }}</div>
                    <audio
                      v-if="item.fsgoRecordUrl"
                      class="c-m-t-15"
                      controls
                      :controlsList="
                        osg.has('ServiceAppointment,downloadAudio') ? null : 'nodownload'
                      "
                      @contextmenu.prevent="osg.has('ServiceAppointment,downloadAudio') ? true : ''"
                      :src="item.fsgoRecordUrl"
                    >
                      您的浏览器不支持 audio 标签。
                    </audio>
                  </div>
                  <div class="activity-card-footer">
                    <span></span>
                    <span>生成记录时间：{{ item.createTime }}</span>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="操作记录" name="history">
              <div
                class="box-center-content"
                v-infinite-scroll="getHistory"
                :infinite-scroll-immediate="true"
              >
                <c-modify
                  :historyFpi="historyFpi"
                  :fields="extFields"
                  :fieldsObj="fieldsObj"
                  :options="options"
                  ref="modify"
                ></c-modify>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="box-right" :class="collapse ? 'box-collapse' : ''">
          <div class="box-right-header">
            <i class="el-icon-d-arrow-left" @click="collapse = false" v-if="collapse"></i>
            <i class="el-icon-d-arrow-right" @click="collapse = true" v-else></i>
          </div>
          <div class="box-right-content" v-show="!collapse">
            <el-collapse v-model="activeNames">
              <el-collapse-item name="1" v-if="tenantId != '2530349872480957853'">
                <template slot="title">
                  <span>线索</span>
                  <el-button type="text" icon="el-icon-plus" @click.stop="newLead">
                    添加线索
                  </el-button>
                </template>
                <div class="card-group">
                  <div class="card-item" v-for="(item, i) of lead.relatedData" :key="i">
                    <div>
                      <i class="el-icon-s-custom card-item-logo" style="color: #606266"></i>
                    </div>
                    <div>
                      <p>
                        <el-link
                          @click="osg.open('', '', '_blank', '/Lead/' + item._id)"
                          target="_blank"
                        >
                          {{ item.name }}
                        </el-link>
                      </p>
                      <p>
                        手机号：{{ item.phone }}
                        <!-- <el-link :href="'tel:' + item.phone"
                             target="_blank">
                      <i class="el-icon-phone-outline"></i>
                    </el-link> -->
                      </p>
                      <p>状态：{{ osg.formatCascade('LEADSTATUS', item.leadStatus) }}</p>
                      <p>留咨时间：{{ item.customTime }}</p>
                      <p>
                        省市区：{{
                          `${formatProvince(item.province)}${formatCity(item.city)}${formatDistrict(
                            item.district
                          )}`
                        }}
                      </p>
                      <p>信息渠道：{{ osg.formatCascade('channel', item.channel) }}</p>
                    </div>
                    <!-- <i class="el-icon-close card-item-icon-remove" @click="removeLead(item)"></i> -->
                    <i class="el-icon-edit card-item-icon-edit" @click="editLead(item)"></i>
                  </div>
                </div>
              </el-collapse-item>
              <el-collapse-item name="2" v-if="tenantId != '2530349872480957853'">
                <template slot="title">
                  <span>合同</span>
                </template>
                <div class="card-group">
                  <div class="card-item" v-for="(item, i) of contractList" :key="i">
                    <div>
                      <i class="el-icon-tickets card-item-logo"></i>
                    </div>
                    <div>
                      <p>
                        <el-link
                          @click="osg.open('', '', '_blank', '/Contract/' + item._id)"
                          target="_blank"
                        >
                          {{ item.contactsName }}
                        </el-link>
                      </p>
                      <p>合同编号：{{ item.contractdocNum }}</p>
                      <p>客户电话：{{ item.contactsPhone }}</p>
                    </div>
                  </div>
                </div>
              </el-collapse-item>
              <el-collapse-item name="4" v-if="tenantId != '2530349872480957853'">
                <template slot="title">
                  <span>质保</span>
                </template>
                <div class="card-group">
                  <div class="card-item" v-for="(item, i) of warrantyList" :key="i">
                    <div>
                      <i class="el-icon-tickets card-item-logo"></i>
                    </div>
                    <div>
                      <p>
                        <el-link
                          @click="
                            osg.open(
                              '',
                              '',
                              '_blank',
                              `/Warranty/${item.extId}?warrantyId=${item._id}`
                            )
                          "
                          target="_blank"
                        >
                          {{ item.ownerName }}
                        </el-link>
                      </p>
                      <!-- <p>业主名称：{{ item.ownerName }}</p> -->
                    </div>
                  </div>
                </div>
              </el-collapse-item>
              <el-collapse-item name="5" v-if="tenantId != '2530349872480957853'">
                <template slot="title">
                  <span>工单</span>
                  <!-- <el-button type="text" icon="el-icon-plus" @click.stop="newServiceAppointment">
                    添加工单
                  </el-button> -->
                </template>
                <div class="card-group">
                  <div
                    class="card-item"
                    v-for="(item, i) of serviceAppointment.relatedData"
                    :key="i"
                  >
                    <div>
                      <i class="el-icon-tickets card-item-logo"></i>
                    </div>
                    <div>
                      <p>
                        标题：
                        <!-- <el-link :href="'/Flow/serviceAppointment/' + item._id" target="_blank">
                          {{ item.title }}
                        </el-link> -->
                        <span
                          class="c-blue c_pointer"
                          @click="
                            osg.open('', '', '_blank', '/Flow/serviceAppointment/' + item._id)
                          "
                        >
                          {{ item.title }}
                        </span>
                      </p>
                      <p>编号： {{ item.orderNum }}</p>
                      <p v-if="item.stage">阶段：{{ osg.codelabel('stage', item.stage) }}</p>
                      <p v-if="item.status">状态：{{ osg.codelabel('status', item.status) }}</p>
                      <p v-if="item.exts.workflowDefId">
                        类型：{{ osg.codelabel('workflowDefId', item.exts.workflowDefId) }}
                      </p>
                      <p>创建：{{ item.createTime }}</p>
                    </div>
                    <!-- <i
                  class="el-icon-close card-item-icon-remove"
                  @click="removeServiceAppointment(item)"
                ></i> -->
                    <!-- <i
                      class="el-icon-edit card-item-icon-edit"
                      @click="editServiceAppointment(item)"
                    ></i> -->
                  </div>
                </div>
              </el-collapse-item>
              <el-collapse-item name="6">
                <template slot="title">
                  <span>优惠券</span>
                </template>
                <div class="card-group">
                  <div class="card-item" v-for="(item, i) of couponPrinting.relatedData" :key="i">
                    <div>
                      <i class="el-icon-tickets card-item-logo"></i>
                    </div>
                    <div>
                      <p>券号： {{ item._id }}</p>
                      <p>优惠券名称： {{ item.title }}</p>
                      <p>购买价格： ¥{{ item.price }}</p>
                      <p>优惠券面值： ¥{{ item.value }}</p>
                      <p>优惠券折扣类型：{{ osg.codelabel('CpsDiscountType', item.type) }}</p>
                      <p>优惠券激活时间：{{ item.exts.activationDate }}</p>
                      <p>优惠券失效时间：{{ item.exts.dueDate }}</p>
                      <p>使用条件： ¥{{ item.prerequisites }}</p>
                      <p>状态：{{ osg.codelabel('couponState', item.status) }}</p>
                    </div>
                    <!-- <i
                  class="el-icon-close card-item-icon-remove"
                  @click="removeServiceAppointment(item)"
                ></i> -->
                  </div>
                </div>
              </el-collapse-item>
              <!-- <el-collapse-item name="2" v-if="false">
            <template slot="title">
              <span>公司</span>
              <el-button type="text" icon="el-icon-plus" @click.stop="newCompany">
                添加公司
              </el-button>
            </template>
            <div class="card-group">
              <div class="card-item" v-for="(item, i) of company.relatedData" :key="i">
                <div>
                  <i class="el-icon-office-building card-item-logo"></i>
                </div>
                <div>
                  <p>
                    <el-link :href="'/company/' + item._id" target="_blank">
                      {{ item.name }}
                    </el-link>
                  </p>
                  <p class="card-item-link">
                    <el-link :href="item.website" target="_blank">
                      {{ item.domainName }}
                    </el-link>
                  </p>
                </div>
                <i class="el-icon-close card-item-icon-remove" @click="removeCompany(item)"></i>
                <i class="el-icon-edit card-item-icon-edit" @click="editCompany(item)"></i>
              </div>
            </div>
          </el-collapse-item> -->
              <!-- <el-collapse-item name="3" v-if="false">
            <template slot="title">
              <span>地址</span>
              <el-button type="text" icon="el-icon-plus" @click.stop="newAddress">
                添加地址
              </el-button>
            </template>
            <div class="card-group">
              <div class="card-item" v-for="(item, i) of address.relatedData" :key="i">
                <div>
                  <i class="el-icon-location-information card-item-logo"></i>
                </div>
                <div>
                  <p>
                    <el-link :href="'/address/' + item._id" target="_blank">
                      {{ item.address }}
                    </el-link>
                  </p>
                  <p></p>
                </div>
                <i class="el-icon-close card-item-icon-remove" @click="removeAddress(item)"></i>
                <i class="el-icon-edit card-item-icon-edit" @click="editAddress(item)"></i>
              </div>
            </div>
          </el-collapse-item> -->
            </el-collapse>
          </div>
          <el-drawer
            custom-class="c-drawer"
            title="添加工单"
            :visible.sync="serviceAppointment.openRelate"
            direction="rtl"
            @close="initServiceAppointment"
            :wrapperClosable="false"
            :close-on-press-escape="false"
          >
            <div class="el-drawer__content">
              <el-tabs v-model="serviceAppointment.activeName" type="card">
                <el-tab-pane label="选择已有工单" name="search">
                  <p class="c-m-b-10 c-font-13">请输入工单标题/客户名称进行搜索</p>
                  <el-select
                    v-model="serviceAppointment.searchObj"
                    filterable
                    remote
                    reserve-keyword
                    placeholder
                    :remote-method="getServiceAppointmentData"
                    clearable
                    @clear="getServiceAppointmentData"
                    :loading="false"
                    @change="$forceUpdate()"
                    class="c-w-1"
                  >
                    <el-option
                      v-for="item in serviceAppointment.data"
                      :key="item._id"
                      :label="item.title"
                      :value="item"
                    >
                      <span class="c-fl">{{ item.title }}</span>
                      <span class="c-fr c-font-13">{{ item.name }}</span>
                    </el-option>
                  </el-select>
                </el-tab-pane>
                <el-tab-pane label="新建工单" name="create">
                  <el-form
                    :model="serviceAppointment.formData"
                    :rules="rules"
                    ref="serviceAppointmentFormData"
                    label-width="90px"
                    label-position="left"
                    hide-required-asterisk
                  >
                    <el-form-item label="客户姓名" prop="name">
                      <el-input v-model="serviceAppointment.formData.name"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号" prop="phone">
                      <el-input v-model="serviceAppointment.formData.phone"></el-input>
                    </el-form-item>
                    <el-form-item
                      label="省市区"
                      prop="area"
                      :rules="{
                        required: true,
                        type: 'array',
                        trigger: 'blur',
                        message: '省市区不能为空'
                      }"
                    >
                      <el-cascader
                        popper-class="cascaderLabelHide-wrapper"
                        ref="areaSelectorSA"
                        :options="area.options"
                        :props="{
                          expandTrigger: 'hover'
                        }"
                        v-model="serviceAppointment.formData.area"
                        clearable
                      ></el-cascader>
                    </el-form-item>
                    <el-form-item label="详细地址" prop="address">
                      <el-input v-model="serviceAppointment.formData.address"></el-input>
                    </el-form-item>
                    <el-form-item label="工单标题" prop="title">
                      <el-input v-model="serviceAppointment.formData.title"></el-input>
                    </el-form-item>
                    <el-form-item label="优先级">
                      <el-radio-group
                        v-model="serviceAppointment.formData.priority"
                        @change="$forceUpdate()"
                      >
                        <el-radio
                          v-for="item of options.priority"
                          :key="item.value"
                          :label="Number(item.value)"
                        >
                          {{ item.label }}
                        </el-radio>
                      </el-radio-group>
                    </el-form-item>
                    <el-form-item label="预约时间" prop="applyTime">
                      <el-date-picker
                        v-model="serviceAppointment.formData.applyTime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        type="datetime"
                        placeholder="选择日期时间"
                      ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="备注" prop="describe">
                      <el-input
                        type="textarea"
                        :rows="2"
                        v-model="serviceAppointment.formData.describe"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="阶段">
                      <el-select v-model="serviceAppointment.formData.stage">
                        <el-option
                          v-for="item in options.stage"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="状态">
                      <el-select v-model="serviceAppointment.formData.status">
                        <el-option
                          v-for="item in options.status"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                          v-show="serviceAppointment.formData.stage == item.value.slice(0, -2)"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-form>
                </el-tab-pane>
              </el-tabs>
            </div>
            <div class="el-drawer__footer" v-if="serviceAppointment.activeName == 'search'">
              <el-button
                type="primary"
                :disabled="!serviceAppointment.searchObj._id"
                @click="
                  saveServiceAppointment('search');
                  initServiceAppointment();
                "
              >
                保存
              </el-button>
              <el-button plain @click="initServiceAppointment()">取消</el-button>
            </div>
            <div class="el-drawer__footer" v-if="serviceAppointment.activeName == 'create'">
              <el-button type="primary" @click="saveServiceAppointment()">保存</el-button>
              <el-button plain @click="initServiceAppointment">取消</el-button>
            </div>
          </el-drawer>
          <el-drawer
            custom-class="c-drawer"
            title="编辑工单"
            :visible.sync="serviceAppointment.openEdit"
            direction="rtl"
            @close="initServiceAppointment"
            :wrapperClosable="false"
            :close-on-press-escape="false"
          >
            <div class="el-drawer__content">
              <el-form
                :model="serviceAppointment.formData"
                :rules="rules"
                ref="serviceAppointmentFormData"
                label-width="90px"
                label-position="left"
                hide-required-asterisk
              >
                <el-form-item label="客户姓名" prop="name">
                  <el-input v-model="serviceAppointment.formData.name"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="phone">
                  <el-input v-model="serviceAppointment.formData.phone"></el-input>
                </el-form-item>
                <el-form-item
                  label="省市区"
                  prop="area"
                  :rules="{
                    required: true,
                    type: 'array',
                    trigger: 'blur',
                    message: '省市区不能为空'
                  }"
                >
                  <el-cascader
                    popper-class="cascaderLabelHide-wrapper"
                    ref="areaSelectorSA"
                    :options="area.options"
                    :props="{
                      expandTrigger: 'hover'
                    }"
                    v-model="serviceAppointment.formData.area"
                    clearable
                  ></el-cascader>
                </el-form-item>
                <el-form-item label="详细地址" prop="address">
                  <el-input v-model="serviceAppointment.formData.address"></el-input>
                </el-form-item>
                <el-form-item label="工单标题" prop="title">
                  <el-input v-model="serviceAppointment.formData.title"></el-input>
                </el-form-item>
                <el-form-item label="优先级">
                  <el-radio-group
                    v-model="serviceAppointment.formData.priority"
                    @change="$forceUpdate()"
                  >
                    <el-radio
                      v-for="item of options.priority"
                      :key="item.value"
                      :label="item.value"
                    >
                      {{ item.label }}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="预约时间">
                  <el-date-picker
                    v-model="serviceAppointment.formData.applyTime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="datetime"
                    placeholder="选择日期时间"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label="描述" prop="describe">
                  <el-input type="textarea" :rows="2" v-model="formData.describe"></el-input>
                </el-form-item>
                <el-form-item label="阶段">
                  <el-select
                    v-model="serviceAppointment.formData.stage"
                    :disabled="tenantId == '1340835581184723420'"
                  >
                    <el-option
                      v-for="item in options.stage"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="状态">
                  <el-select
                    v-model="serviceAppointment.formData.status"
                    :disabled="tenantId == '1340835581184723420'"
                  >
                    <el-option
                      v-for="item in options.status"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                      v-show="serviceAppointment.formData.stage == item.value.slice(0, -2)"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </div>
            <div class="el-drawer__footer">
              <el-button type="primary" @click="saveServiceAppointment()">保存</el-button>
              <el-button plain @click="initServiceAppointment()">取消</el-button>
            </div>
          </el-drawer>
          <el-drawer
            custom-class="c-drawer"
            title="添加公司"
            :visible.sync="company.openRelate"
            direction="rtl"
            @close="initCompany"
            :wrapperClosable="false"
            :close-on-press-escape="false"
          >
            <div class="el-drawer__content">
              <el-tabs v-model="company.activeName" type="card">
                <el-tab-pane label="选择已有公司" name="search">
                  <p class="c-m-b-10 c-font-13">请输入公司名称进行搜索</p>
                  <el-select
                    v-model="formData.companyIds"
                    multiple
                    filterable
                    remote
                    reserve-keyword
                    placeholder
                    :remote-method="getCompanyData"
                    clearable
                    @clear="getCompanyData"
                    :loading="false"
                    @change="$forceUpdate()"
                    class="c-w-1"
                  >
                    <el-option
                      v-for="item in company.data"
                      :key="item._id"
                      :label="item.name"
                      :value="item._id"
                    ></el-option>
                  </el-select>
                </el-tab-pane>
                <el-tab-pane label="新建公司" name="create">
                  <el-form
                    :model="company.formData"
                    :rules="rules"
                    ref="companyFormData"
                    label-width="70px"
                    label-position="left"
                    hide-required-asterisk
                  >
                    <el-form-item label="名称" prop="name">
                      <el-input v-model="company.formData.name"></el-input>
                    </el-form-item>
                    <el-form-item label="公司编号" prop="accountNumber">
                      <el-input v-model="company.formData.accountNumber"></el-input>
                    </el-form-item>
                    <el-form-item label="行业" prop="industry">
                      <el-select v-model="company.formData.industry">
                        <el-option
                          v-for="item in options.industry"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="联系电话">
                      <el-input v-model="company.formData.phone"></el-input>
                    </el-form-item>
                    <el-form-item label="客户ID">
                      <el-input v-model="company.formData.ownerId"></el-input>
                    </el-form-item>
                    <el-form-item label="类型">
                      <el-select v-model="company.formData.type">
                        <el-option
                          v-for="item in options.companytype"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="描述">
                      <el-input v-model="company.formData.description"></el-input>
                    </el-form-item>
                    <el-form-item label="网址" prop="website">
                      <el-input v-model="company.formData.website"></el-input>
                    </el-form-item>
                    <el-form-item label="域名" prop="domainName">
                      <el-autocomplete
                        v-model="company.formData.domainName"
                        :fetch-suggestions="querySearch"
                      ></el-autocomplete>
                    </el-form-item>
                    <el-form-item label="成立时间" prop="foundTime">
                      <el-date-picker
                        v-model="company.formData.foundTime"
                        type="date"
                        placeholder="选择日期"
                      ></el-date-picker>
                    </el-form-item>
                  </el-form>
                </el-tab-pane>
              </el-tabs>
            </div>
            <div class="el-drawer__footer" v-if="company.activeName == 'search'">
              <el-button
                type="primary"
                @click="
                  doSave();
                  initCompany();
                "
              >
                保存
              </el-button>
              <el-button
                plain
                @click="
                  getData();
                  initCompany();
                "
              >
                取消
              </el-button>
            </div>
            <div class="el-drawer__footer" v-if="company.activeName == 'create'">
              <el-button
                type="primary"
                @click="
                  saveCompany();
                  initCompany();
                "
              >
                保存
              </el-button>
              <el-button plain @click="initCompany">取消</el-button>
            </div>
          </el-drawer>
          <el-drawer
            custom-class="c-drawer"
            title="编辑公司"
            :visible.sync="company.openEdit"
            direction="rtl"
            @close="initCompany"
            :wrapperClosable="false"
            :close-on-press-escape="false"
          >
            <div class="el-drawer__content">
              <el-form
                :model="company.formData"
                :rules="rules"
                ref="companyFormData"
                label-width="70px"
                label-position="left"
                hide-required-asterisk
              >
                <el-form-item label="名称" prop="name">
                  <el-input v-model="company.formData.name"></el-input>
                </el-form-item>
                <el-form-item label="公司编号" prop="accountNumber">
                  <el-input v-model="company.formData.accountNumber"></el-input>
                </el-form-item>
                <el-form-item label="行业" prop="industry">
                  <el-select v-model="company.formData.industry">
                    <el-option
                      v-for="item in options.industry"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="联系电话">
                  <el-input v-model="company.formData.phone"></el-input>
                </el-form-item>
                <el-form-item label="客户ID">
                  <el-input v-model="company.formData.ownerId"></el-input>
                </el-form-item>
                <el-form-item label="类型">
                  <el-select v-model="company.formData.type">
                    <el-option
                      v-for="item in options.companytype"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="描述">
                  <el-input v-model="company.formData.description"></el-input>
                </el-form-item>
                <el-form-item label="网址" prop="website">
                  <el-input v-model="company.formData.website"></el-input>
                </el-form-item>
                <el-form-item label="域名" prop="domainName">
                  <el-autocomplete
                    v-model="company.formData.domainName"
                    :fetch-suggestions="querySearch"
                  ></el-autocomplete>
                </el-form-item>
                <el-form-item label="成立时间" prop="foundTime">
                  <el-date-picker
                    v-model="company.formData.foundTime"
                    type="date"
                    placeholder="选择日期"
                  ></el-date-picker>
                </el-form-item>
              </el-form>
            </div>
            <div class="el-drawer__footer">
              <el-button
                type="primary"
                @click="
                  saveCompany();
                  initCompany();
                "
              >
                保存
              </el-button>
              <el-button plain @click="initCompany()">取消</el-button>
            </div>
          </el-drawer>
          <el-drawer
            custom-class="c-drawer"
            title="地址信息"
            :visible.sync="address.openEdit"
            direction="rtl"
            @close="address"
            :wrapperClosable="false"
            :close-on-press-escape="false"
          >
            <div class="el-drawer__content">
              <el-form
                :model="address.formData"
                :rules="rules"
                ref="addressFormData"
                label-width="110px"
                label-position="left"
                hide-required-asterisk
              >
                <el-form-item label="地址" prop="address">
                  <el-input v-model="address.formData.address"></el-input>
                </el-form-item>
                <el-form-item label="地址类型" prop="addressType">
                  <el-select v-model="address.formData.addressType">
                    <el-option
                      v-for="item in options.addressType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                      :disabled="item.value != '0'"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="地址说明" prop="addressDescription">
                  <el-input v-model="address.formData.addressDescription"></el-input>
                </el-form-item>
                <el-form-item label="地理编码准确度" prop="accuracy">
                  <el-input v-model="address.formData.accuracy"></el-input>
                </el-form-item>
                <el-form-item label="经度" prop="longitude">
                  <el-input v-model="address.formData.longitude"></el-input>
                </el-form-item>
                <el-form-item label="纬度" prop="dimension">
                  <el-input v-model="address.formData.dimension"></el-input>
                </el-form-item>
                <el-form-item label="位置类型" prop="locationType">
                  <el-select v-model="address.formData.locationType">
                    <el-option
                      v-for="item in options.locationType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="邮编" prop="zipCode">
                  <el-input v-model="address.formData.zipCode"></el-input>
                </el-form-item>
                <el-form-item label="国家" prop="country">
                  <el-input v-model="address.formData.country"></el-input>
                </el-form-item>
                <el-form-item
                  label="省市区"
                  prop="area"
                  :rules="{
                    required: true,
                    type: 'array',
                    trigger: 'blur',
                    message: '省市区不能为空'
                  }"
                >
                  <el-cascader
                    :options="area.options"
                    :props="area.props"
                    v-model="address.formData.area"
                    clearable
                  ></el-cascader>
                </el-form-item>
                <el-form-item label="街道地址" prop="streetName">
                  <el-input v-model="address.formData.streetName"></el-input>
                </el-form-item>
                <el-form-item label="时区" prop="timeZone">
                  <el-input v-model="address.formData.timeZone"></el-input>
                </el-form-item>
              </el-form>
            </div>
            <div class="el-drawer__footer">
              <el-button type="primary" @click="saveAddress()">保存</el-button>
              <el-button plain @click="initAddress()">取消</el-button>
            </div>
          </el-drawer>
          <!--关联/添加线索-->
          <el-drawer
            custom-class="c-drawer"
            title="添加线索"
            :visible.sync="lead.openRelate"
            direction="rtl"
            :wrapperClosable="false"
            :close-on-press-escape="false"
          >
            <div class="el-drawer__content">
              <el-tabs v-model="lead.activeName" type="card">
                <!-- <el-tab-pane label="选择已有线索" name="search">
              <p class="c-m-b-10 c-font-13">请输入客户姓名/手机号进行搜索</p>
              <el-select
                v-model="formData.leadIds"
                filterable
                remote
                reserve-keyword
                placeholder
                :remote-method="getLead"
                clearable
                @clear="getLead"
                :loading="false"
                @change="$forceUpdate()"
                class="c-w-1"
              >
                <el-option
                  v-for="item in lead.data"
                  :key="item._id"
                  :label="item.name"
                  :value="item._id"
                >
                  <span class="c-fl">{{ item.name }}</span>
                  <span class="c-fr c-font-13">{{ item.phone }}</span>
                </el-option>
              </el-select>
            </el-tab-pane> -->
                <el-tab-pane label="新增线索" name="create">
                  <el-form
                    :model="lead.formData"
                    :rules="rules"
                    ref="leadFormData"
                    label-width="90px"
                    label-position="left"
                    hide-required-asterisk
                  >
                    <el-form-item label="姓名" prop="name">
                      <el-input v-model="lead.formData.name" suffix-icon="el-icon-user"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号" prop="phone">
                      <el-input
                        v-model="lead.formData.phone"
                        suffix-icon="el-icon-mobile-phone"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="邮箱" prop="email">
                      <el-input
                        v-model="lead.formData.email"
                        suffix-icon="el-icon-message"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="地址" prop="address">
                      <el-input v-model="lead.formData.address"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="状态" prop="leadStatus">
                  <el-select v-model="lead.formData.leadStatus">
                    <el-option
                      v-for="item in options.leadStatus"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item> -->
                    <!-- <el-form-item label="阶段" prop="lifecycleStage">
                  <el-select v-model="lead.formData.lifecycleStage">
                    <el-option
                      v-for="item in options.lifecycleStage"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item> -->
                  </el-form>
                </el-tab-pane>
              </el-tabs>
            </div>
            <div class="el-drawer__footer" v-if="lead.activeName == 'search'">
              <el-button type="primary" @click="saveLead()">保存</el-button>
              <el-button plain @click="initLead">取消</el-button>
            </div>
            <div class="el-drawer__footer" v-if="lead.activeName == 'create'">
              <el-button type="primary" @click="saveLead()">保存</el-button>
              <el-button plain @click="initLead">取消</el-button>
            </div>
          </el-drawer>
          <!--编辑客户-->
          <el-drawer
            custom-class="c-drawer"
            title="编辑线索"
            :visible.sync="lead.openEdit"
            direction="rtl"
            :wrapperClosable="false"
            :close-on-press-escape="false"
          >
            <div class="el-drawer__content">
              <el-form
                :model="lead.formData"
                :rules="rules"
                ref="leadFormData"
                label-width="90px"
                label-position="left"
                hide-required-asterisk
              >
                <el-form-item label="姓名" prop="name">
                  <el-input v-model="lead.formData.name"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="phone">
                  <el-input v-model="lead.formData.phone"></el-input>
                </el-form-item>
                <el-form-item label="邮箱" prop="email">
                  <el-input v-model="lead.formData.email"></el-input>
                </el-form-item>
                <el-form-item label="地址" prop="address">
                  <el-input v-model="lead.formData.address"></el-input>
                </el-form-item>
                <el-form-item label="状态" prop="leadStatus">
                  <el-select v-model="lead.formData.leadStatus">
                    <el-option
                      v-for="item in options.leadStatus"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="阶段" prop="lifecycleStage">
                  <el-select v-model="lead.formData.lifecycleStage">
                    <el-option
                      v-for="item in options.lifecycleStage"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </div>
            <div class="el-drawer__footer">
              <el-button type="primary" @click="saveLead()">保存</el-button>
              <el-button plain @click="initLead()">取消</el-button>
            </div>
          </el-drawer>
        </div>
      </div>
    </div>

    <!-- 跟进纪录弹窗 -->
    <el-dialog
      title="综合跟进表"
      id="comprehensiveDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="!phoneStripData.phoneStripPopUp && record.openRecord"
      @close="
        record.recordFormData = {};
        record.SArecordFormData = {
          gpsPoint: {},
          exts: {}
        };
      "
    >
      <template v-if="!phoneStripData.isTransfer">
        <el-form
          :model="record.recordFormData"
          :rules="rules"
          ref="recordFormData"
          label-width="3px"
          label-position="top"
          hide-required-asterisk:true
          :inline="true"
        >
          <el-divider content-position="center">
            <i class="el-icon-info"></i>
            以下为跟进记录信息
          </el-divider>

          <el-form-item
            style="width: 46%"
            label="通话状态"
            prop="dedicateMode"
            :rules="{
              required: true,
              type: 'array',
              trigger: 'blur',
              message: '通话状态不能为空'
            }"
          >
            <el-cascader
              popper-class="cascaderLabelHide-wrapper"
              ref="cascaderRRdedicateMode"
              clearable
              v-model="record.recordFormData.dedicateMode"
              :options="options['LEADSTATUS']"
              :props="{
                checkStrictly: false,
                label: 'name',
                expandTrigger: 'hover'
              }"
            >
              <template slot-scope="{ node, data }" v-show="data.value == 0">
                <span>{{ data.name }}</span>
              </template>
            </el-cascader>
          </el-form-item>
          <el-form-item style="width: 46%" label="下次联系时间" prop="nextTime">
            <el-date-picker
              v-model="record.recordFormData.nextTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="下次联系时间"
            ></el-date-picker>
          </el-form-item>
        </el-form>
        <el-input
          type="textarea"
          v-model="record.recordFormData.memo"
          maxlength="200"
          show-word-limit
          placeholder="备注"
        ></el-input>

        <!-- <div class="c-flex c-flex-end c_m_t_n  m-b-10">
              <el-button type="primary"
                         @click="saveRecord(0)">保存状态</el-button>
            </div> -->

        <el-divider content-position="center">
          <i class="el-icon-info"></i>
          以下为建单信息
        </el-divider>

        <el-form
          :model="record.SArecordFormData"
          :rules="rules"
          ref="SArecordFormData"
          label-width="110px"
          label-position="left"
          hide-required-asterisk:true
        >
          <el-form-item label="工单标题" prop="title">
            <el-input v-model="record.SArecordFormData.title"></el-input>
          </el-form-item>
          <el-form-item label="客户姓名" prop="name">
            <el-autocomplete
              popper-class="my-autocomplete"
              v-model="record.SArecordFormData.name"
              :fetch-suggestions="querySearch"
              placeholder="请输客户名称"
              @select="handleSelect"
              hide-loading
              value-key="name"
            >
              <i class="el-icon-search el-input__icon" slot="suffix"></i>
              <template slot-scope="{ item }">
                <p class="c-flex c-flex-between">
                  <span>{{ item.name }}</span>
                  <span>{{ item.phone }}</span>
                </p>
              </template>
            </el-autocomplete>
          </el-form-item>
          <el-form-item label="客户手机" prop="phone">
            <el-input v-model="record.SArecordFormData.phone"></el-input>
          </el-form-item>
          <el-form-item
            label="省市区"
            prop="area"
            :rules="{
              required: true,
              type: 'array',
              trigger: 'blur',
              message: '省市区不能为空'
            }"
          >
            <el-cascader
              :options="area.options"
              popper-class="cascaderLabelHide-wrapper"
              :props="{
                expandTrigger: 'hover'
              }"
              ref="areaSelectorRSA"
              v-model="record.SArecordFormData.area"
              clearable
              @change="
                if (record.SArecordFormData.subdistrict) {
                  record.SArecordFormData.subdistrict = '';
                }
                osg.getSubdistricts(record.SArecordFormData.area, result => {
                  options.subdistricts2 = result;
                  $forceUpdate();
                });
              "
            ></el-cascader>
          </el-form-item>
          <el-form-item label="街道" prop="subdistrict">
            <el-select v-model="record.SArecordFormData.subdistrict">
              <el-option
                v-for="item in options.subdistricts2"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="小区" prop="community">
            <el-input v-model="record.SArecordFormData.community"></el-input>
          </el-form-item>
          <el-form-item label="详细地址" prop="address">
            <el-autocomplete
              :fetch-suggestions="osg.inputtips"
              @select="osg.inputtipsSelect"
              autosize
              type="textarea"
              v-model="record.SArecordFormData.address"
            >
              <template slot-scope="{ item }">
                <div class="c-flex">
                  <span>{{ item.name }}</span>
                  <span style="margin-left: 6px;color: #ccc;">{{ item.district }}</span>
                </div>
              </template>
            </el-autocomplete>
          </el-form-item>
          <!-- <el-form-item label="经度"
                            v-show="false">
                <el-input v-model="record.SArecordFormData.gpsPoint.longitude"
                          disabled
                          placeholder="根据地址自动生成"></el-input>
              </el-form-item>
              <el-form-item label="纬度"
                            v-show="false">
                <el-input v-model="record.SArecordFormData.gpsPoint.latitude"
                          disabled
                          placeholder="根据地址自动生成"></el-input>
              </el-form-item> -->

          <!-- <el-form-item label="工作类型">
                <el-select v-model="record.SArecordFormData.workType">
                  <el-option v-for="item in options.workType"
                             :key="item.value"
                             :label="item.label"
                             :value="item.value"></el-option>
                </el-select>
              </el-form-item> -->
          <!-- <el-form-item label="预约时间">
                <el-date-picker v-model="record.SArecordFormData.applyTime"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                type="datetime"
                                placeholder="选择日期时间"></el-date-picker>
              </el-form-item> -->
          <!-- <el-form-item label="阶段">
                <el-select v-model="record.SArecordFormData.stage">
                  <el-option v-for="item in options.stage"
                             :key="item.value"
                             :label="item.label"
                             :value="item.value"></el-option>
                </el-select>
              </el-form-item> -->
          <!-- <el-form-item label="线索状态">
                <el-select v-model="record.SArecordFormData['LEADSTATUS']">
                  <el-option v-for="item in options['LEADSTATUS']"
                             :key="item.value"
                             :label="item.label"
                             :value="item.value"></el-option>
                </el-select>
              </el-form-item> -->
          <el-form-item label="备注" prop="describe">
            <el-input
              type="textarea"
              :rows="1"
              v-model="record.SArecordFormData.describe"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="推广码"
                            prop="promoteCode">
                <el-input v-model="record.SArecordFormData.promoteCode"></el-input>
              </el-form-item> -->
          <el-form-item
            label="信息渠道"
            :rules="{
              required: true,
              trigger: 'blur',
              message: '信息渠道不能为空'
            }"
          >
            <el-cascader
              clearable
              popper-class="cascaderLabelHide-wrapper"
              ref="cascaderRRchannel"
              v-model="record.SArecordFormData.channel"
              :options="options.channel"
              :props="{
                label: 'name',
                expandTrigger: 'hover'
              }"
            ></el-cascader>
          </el-form-item>
          <template v-for="(extField, idx) in SAextFields">
            <!-- pc表单展示的字段 -->
            <template v-if="extField.showList && extField.showList.indexOf('2') != -1">
              <el-form-item
                v-if="
                  !extField.frontEndConfig.detailHide &&
                    !extField.frontEndConfig.leadDetailHide &&
                    (!extField.frontEndConfig.showField ||
                      (extField.frontEndConfig.showField &&
                        isShowField(
                          record.SArecordFormData,
                          extField.name,
                          extField.frontEndConfig.showField,
                          extField.frontEndConfig.showValue
                        )))
                "
                :key="idx"
                :label="extField.nameDisp"
                :prop="`exts.${extField.name}`"
                :rules="{
                  required: extField.required == '1',
                  trigger: 'blur',
                  message: extField.nameDisp + '不能为空'
                }"
              >
                <template
                  v-if="
                    extField.type == 'text' ||
                      extField.type == 'textarea' ||
                      extField.type == 'number' ||
                      extField.type == 'phone'
                  "
                >
                  <el-input
                    v-model="record.SArecordFormData.exts[extField.name]"
                    :type="extField.type"
                  ></el-input>
                </template>
                <template v-if="extField.type == 'radio'">
                  <el-radio-group
                    v-model.number="record.SArecordFormData.exts[extField.name]"
                    class="c-flex"
                  >
                    <el-radio
                      v-for="item in options[extField.valueOption]"
                      :key="item.value"
                      :label="item.value"
                    >
                      {{ item.label }}
                    </el-radio>
                  </el-radio-group>
                </template>
                <template v-if="extField.type == 'checkbox'" @change="$forceUpdate()">
                  <el-checkbox-group
                    v-model="record.SArecordFormData.exts[extField.name]"
                    @change="$forceUpdate()"
                  >
                    <el-checkbox
                      v-for="item in options[extField.valueOption]"
                      :label="item.value"
                      :key="item.value"
                    >
                      {{ item.label }}
                    </el-checkbox>
                  </el-checkbox-group>
                </template>
                <template v-if="extField.type == 'select'">
                  <el-select
                    v-model="record.SArecordFormData.exts[extField.name]"
                    placeholder="请选择"
                    clearable
                  >
                    <el-option
                      v-for="item in options[extField.valueOption]"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </template>
                <template v-if="extField.type == 'cascade'">
                  <el-cascader
                    :popper-class="
                      extField.frontEndConfig.cascaderLabelHide ? 'cascaderLabelHide-wrapper' : ''
                    "
                    :ref="extField.valueOption + 'cascader'"
                    v-model="record.SArecordFormData.exts[extField.name]"
                    :options="options[extField.valueOption]"
                    :props="{
                      multiple: extField.frontEndConfig.multiple ? true : false,
                      label: 'name',
                      expandTrigger: extField.frontEndConfig.propsExpandTrigger
                        ? extField.frontEndConfig.propsExpandTrigger
                        : 'click',
                      checkStrictly: extField.frontEndConfig.propsCheckStrictly
                        ? extField.frontEndConfig.propsCheckStrictly
                        : false
                    }"
                    clearable
                    @change="
                      if (extField.frontEndConfig.cascaderLabelHide) {
                        if (
                          $refs[extField.valueOption + 'cascader'] &&
                          $refs[extField.valueOption + 'cascader'][0]
                        ) {
                          $refs[extField.valueOption + 'cascader'][0].dropDownVisible = false; //监听值发生变化就关闭它
                        }
                      }
                      $forceUpdate();
                    "
                  ></el-cascader>
                </template>
                <template v-if="extField.type == 'file'">
                  <el-upload
                    :class="{
                      'c-upload-maxLimit':
                        record.SArecordFormData.exts[extField.name] &&
                        record.SArecordFormData.exts[extField.name].length >=
                          extField.frontEndConfig.max
                    }"
                    :action="upload.url"
                    :data="upload.data"
                    :file-list="record.SArecordFormData.exts[extField.name]"
                    list-type="picture-card"
                    :limit="extField.frontEndConfig.max || 10"
                    :on-exceed="osg.uploadExceed"
                    :before-upload="
                      file => {
                        return osg.beforeUpload(file, extField.frontEndConfig.fileType, 'upload');
                      }
                    "
                    :on-success="
                      (response, file, fileList) => {
                        let returnData = osg.uploadSuccess(
                          response,
                          file,
                          fileList,
                          extField.name,
                          true
                        );
                        record.SArecordFormData.exts[extField.name] = returnData;
                        return returnData;
                      }
                    "
                    :on-error="osg.uploadError"
                    :before-remove="
                      (file, fileList) => {
                        let returnData = osg.beforeRemove(
                          file,
                          fileList,
                          extField.name,
                          record.SArecordFormData.exts[extField.name]
                        );
                        record.SArecordFormData.exts[extField.name] = returnData;
                        return false;
                      }
                    "
                    :on-preview="osg.uploadPreview"
                  >
                    <i class="el-icon-plus"></i>
                    <div
                      slot="file"
                      slot-scope="{ file, fileList }"
                      v-if="extField.frontEndConfig.fileType == 'video'"
                      style="width: 100%; height: 100%"
                    >
                      <span class="el-upload-list__item-actions" style="z-index: 100">
                        <span class="el-upload-list__item-preview" @click="osg.uploadPreview(file)">
                          <i class="el-icon-video-play"></i>
                        </span>

                        <span
                          class="el-upload-list__item-delete"
                          @click="
                            record.SArecordFormData.exts[extField.name] = osg.beforeRemove(
                              file,
                              fileList,
                              extField.name,
                              record.SArecordFormData.exts[extField.name]
                            )
                          "
                        >
                          <i class="el-icon-delete"></i>
                        </span>
                      </span>

                      <video
                        style="width: 100%; height: 100%; object-fit: fill; border-radius: 0"
                        :src="file.url"
                        class="avatar"
                        controls="controls"
                      >
                        您的浏览器不支持视频播放
                      </video>
                    </div>
                  </el-upload>
                  <el-dialog
                    :modal="false"
                    custom-class="dialog-img"
                    :visible.sync="upload.dialogVisible"
                  >
                    <!-- <video
                        v-if="extField.frontEndConfig.fileType == 'video'"
                        style="width:100%;border-radius: 0;"
                        :src="upload.dialogImageUrl"
                        class="avatar"
                        controls="controls"
                      >
                        您的浏览器不支持视频播放
                      </video> -->
                    <img width="100%" :src="upload.dialogImageUrl" alt />
                  </el-dialog>
                </template>

                <template v-if="extField.type == 'time'">
                  <el-time-select
                    v-model="record.SArecordFormData.exts[extField.name]"
                    placeholder="选择时间"
                  ></el-time-select>
                </template>
                <template v-if="extField.type == 'date' || extField.type == 'datetime'">
                  <el-date-picker
                    v-model="record.SArecordFormData.exts[extField.name]"
                    :type="extField.type"
                    :value-format="
                      extField.type == 'datetime' ? 'yyyy-MM-dd HH:mm:ss' : 'yyyy-MM-dd'
                    "
                    placeholder="选择日期"
                  ></el-date-picker>
                </template>
                <template v-if="extField.type == 'switch'">
                  <el-switch
                    v-model="record.SArecordFormData.exts[extField.name]"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    active-value="1"
                    inactive-value="0"
                  ></el-switch>
                </template>
                <template v-if="extField.type == 'rate'">
                  <el-rate
                    v-model.number="record.SArecordFormData.exts[extField.name]"
                    @change="$forceUpdate()"
                  ></el-rate>
                </template>
              </el-form-item>
            </template>
          </template>
        </el-form>

        <div slot="footer" style="display: flex; justify-content: space-between">
          <el-button
            @click="
              record.openRecord = false;
              record.recordFormData = {};
              record.SArecordFormData = {
                gpsPoint: {},
                exts: {}
              };
            "
          >
            取 消
          </el-button>
          <el-button type="primary" @click="saveRecord(0)">保存跟进记录</el-button>
          <el-button type="primary" @click="saveRecord(1)">建 单</el-button>
        </div>
      </template>
      <template v-else>
        <div style="width: 100%; height: 500px">
          <!-- <div class="content-table"> -->
          <el-table
            ref="correspondentTable"
            :data="correspondentList"
            empty-text="该组织暂无人员"
            height="calc(100% - 50px)"
          >
            <el-table-column prop="code" label="编号" width="100"></el-table-column>
            <el-table-column label="姓名" width="100">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="负责人" placement="top-end">
                  <i class="fa fa-user-tie" v-show="scope.row.isHead"></i>
                </el-tooltip>
                {{ scope.row.name }}
              </template>
            </el-table-column>
            <el-table-column prop="phone" label="手机号" width="150px"></el-table-column>
            <el-table-column label="性别" width="100px">
              <template slot-scope="scope">
                <span>
                  {{ scope.row.sex == '1' ? '女' : scope.row.sex == '0' ? '男' : '' }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="角色">
              <template slot-scope="scope">
                <span>{{ renderLabel('roles', scope.row.roleIds) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="email" label="邮箱" width="150px"></el-table-column>
            <el-table-column label="操作" :width="80" fixed="right">
              <template slot-scope="scope">
                <el-button size="mini" @click.native.prevent="transferHandle(scope.row)">
                  转移
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <!-- <el-pagination
              class="pagination"
              @size-change="pageSizeChange"
              @current-change="pageChange"
              :current-page="fpi.page"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="fpi.rows"
              layout="total, sizes, prev, pager, next, jumper"
              :total="fpi.total"
            ></el-pagination> -->
          <!-- </div> -->
        </div>
      </template>
    </el-dialog>

    <el-dialog
      title="跟进记录"
      :visible.sync="record.openLiteRecord"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="
        record.recordFormData = {
          exts: {},
          gpsPoint: {}
        }
      "
    >
      <c-form
        labelWidth="110px"
        :formData="record.recordFormData"
        :fields="followingUpNoteExtFields"
        :area="area"
        :options="options"
        ref="form"
        @changeForm="osg.changeForm"
      ></c-form>
      <div slot="footer">
        <el-button type="primary" @click="saveRecord(0)">保存跟进记录</el-button>
        <el-button
          @click="
            record.recordFormData = {
              exts: {},
              gpsPoint: {}
            };
            record.openLiteRecord = false;
          "
        >
          取 消
        </el-button>
        <!-- <el-button type="primary" @click="doSave">确 定</el-button> -->
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'contact',
  props: {
    serviceState: {
      type: String
    },
    profileTheme: {
      type: Object
    }
  },
  components: {
    phoneStrip: resolve => require(['@/components/phoneStrip.vue'], resolve)
  },
  data() {
    return {
      id: null,
      collapse: false,
      formData: { exts: {} },
      extFields: [],
      SAextFields: [], //工单扩展字段s
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      followingUpNoteExtFields: {}, //跟进记录扩展字段
      fieldsObj: {},
      options: {
        // 客户类型
        codecfg_contactType: { codeId: 'contactType' },
        //客户
        codecfg_leadStatus: { codeId: 'LEADSTATUS' },
        codecfg_lifecycleStage: { codeId: 'LIFECYCLESTAGE' },
        codecfg_callResult: { codeId: 'callResult' },
        codecfg_middleCallResult: { codeId: 'middleCallResult' },
        //工单
        codecfg_priority: { codeId: 'PRIORITY' },
        codecfg_stage: { codeId: 'STAGE' },
        codecfg_status: { codeId: 'STATUS' },
        //公司
        codecfg_companytype: { codeId: 'COMPANYTYPE' },
        codecfg_industry: { codeId: 'INDUSTRY' },
        //地址
        codecfg_addressType: { codeId: 'ADDRESSTYPE' },
        codecfg_locationType: { codeId: 'LOCATIONTYPE' },
        //线索
        cascadeCode_LEADSTATUS: { codeId: 'LEADSTATUS' },
        cascadeCode_channel: { codeId: 'channel' },
        subdistricts: [],
        subdistricts2: [],
        //员工列表
        roles: [],
        //售后类型细分
        cascadeCode_afterSaleType: { codeId: 'afterSaleType' },
        // 是否
        cascadeCode_IS: { codeId: 'IS' },
        //优惠券领取记录
        codecfg_couponState: { codeId: 'couponState' }, //领取状态
        codecfg_CpsDiscountType: { codeId: 'CpsDiscountType' }, //优惠券折扣类型
        // 已购买产品
        codecfg_partUnit: { codeId: 'partUnit' }
      },
      rules: this.$util.rules,
      activeTab: 'log',
      // 日志
      log: {
        fpi: {
          data: []
        },
        searchValue: '',
        searchDate: []
      },
      // 笔记
      noteData: [],
      openNote: false,
      vqeditor: this.$util.vqeditor,
      // 通话记录
      callRecords: {
        fpi: {
          data: []
        },
        searchValue: '',
        searchDate: []
      },
      // UD通话记录
      UDcallRecords: {
        fpi: {
          data: []
        },
        searchValue: '',
        searchDate: []
      },
      // 操作记录
      historyFpi: {
        page: 1,
        rows: 0,
        data: [],
        busy: false
      },
      historyHide: [
        'serviceAppointIds',
        'leadIds',
        'companyIds',
        'contractId',
        'insurancePolicyId',
        'province',
        'city',
        'district'
      ],
      serviceAppointment: {
        relatedData: [],
        openRelate: false,
        openEdit: false,
        Date: [],
        formData: {},
        activeName: 'search',
        searchObj: {}, //搜索选中要关联的工单对象
        searchValue: '',
        fpi: {
          page: 1,
          rows: 20,
          data: []
        }
      },
      SA: {
        formData: { exts: {} },
        open: false
      },
      company: {
        relatedData: [],
        openRelate: false,
        openEdit: false,
        Date: [],
        formData: {},
        activeName: 'search'
      },
      address: {
        relatedData: [],
        openEdit: false,
        formData: {}
      },
      //优惠券领取记录
      couponPrinting: {
        relatedData: [],
        openEdit: false,
        formData: {}
      },
      lead: {
        relatedData: [],
        openRelate: false,
        openEdit: false,
        Date: [],
        formData: {},
        activeName: 'create'
      },
      // 客户已购买的产品档案
      purchase: {
        extFields: [],
        fpi: { page: 1, rows: 20, data: [] },
        formData: {},
        open: false,
        searchDate: [],
        searchValue: '',
        selectedRows: []
      },
      //地址级联
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      },
      activeNames: ['1', '2', '3', '4', '5', '6', '7'],
      // 跟进记录列表
      record: {
        fpi: {
          data: []
        },
        searchValue: '',
        searchDate: [],
        openRecord: false, // 跟进记录弹窗
        recordFormData: { exts: {} }, //跟进记录表单-上
        SArecordFormData: { gpsPoint: {}, exts: {} }, //跟进记录表单-下（工单信息）
        callData: [], //跟进记录-通话记录
        openCallRecord: false, //跟进记录-通话记录弹窗
        openLiteRecord: false //跟进记录弹窗-精简版
      },
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      },
      callId: '', //呼叫回调Id
      contractList: [], //合同列表
      warrantyList: [], // 质保列表
      tenantId: '', //租户id
      messagesContent: '', //短信内容
      openMessages: false, //短信弹窗
      phoneStripData: {}, //电话条数据
      correspondentList: [], //客服列表(空闲)
      entity: '', //
      storagetransfer: null //   暂存被转移的客服
    };
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    }
  },
  beforeDestroy() {
    this.editor = null;
    delete this.editor;
  },
  mounted() {
    window.$this = this;
    this.id = this.osg.param('id');
    this.osg.setLastRowId('Contacts', this.id);
    let acount = this.osg.isJson(sessionStorage['loginAccount'])
      ? JSON.parse(sessionStorage['loginAccount'])
      : {};
    this.tenantId = acount.tenantId;
    // this.getFields();
    this.getSAextFields();
    this.osg.getFields(
      'followingUpNote',
      () => {
        console.log(this.followingUpNoteExtFields);
        this.followingUpNoteExtFields = this.followingUpNoteExtFields.filter(fItem =>
          this.tenantId != '1340835581184723420' ? true : 1 != fItem.preset
        );
        this.osg.getFields('contacts', () => {
          this.getData(() => {
            this.osg.getSubdistricts(this.formData.area, result => {
              this.options.subdistricts = result;
              this.$forceUpdate();
            });
            //从列表点击打电话，自动调打电话接口和弹出弹窗
            const isCall = this.$route.params.isCall;
            if (isCall) {
              this.openRecordFun();
              this.osg.sobot.selfCallOut(
                {
                  callNum: this.formData.phone,
                  bizType: 'contacts',
                  bizId: this.formData._id
                },
                this.callOutBack
              );
              this.$route.params.isCall = null; //消除来电标识
            }
            this.getContract();
            this.getWarranty();
            this.getCouponPrintings(); //获取优惠券
          });
        });
      },
      this,
      'followingUpNoteExtFields'
    );

    if (this.tenantId == '2530349872480957853') {
      this.activeTab = 'purchase';
      this.purchaseFieldsQuery(() => {});
      this.SAExtFieldsQuery();
    }
  },
  methods: {
    pageSizeChange(pageSize) {
      switch (this.activeTab) {
        case 'purchase':
          this.purchase.fpi.rows = pageSize;
          this.purchaseQuery();
          break;
        case 'serviceAppointment':
          this.serviceAppointment.fpi.rows = pageSize;
          this.getServiceAppointments();
          break;
      }
    },
    pageChange(currentPage) {
      switch (this.activeTab) {
        case 'purchase':
          this.purchase.fpi.page = currentPage;
          this.purchaseQuery();
          break;
        case 'serviceAppointment':
          this.serviceAppointment.fpi.page = currentPage;
          this.getServiceAppointments();
          break;
      }
    },
    formatCallResult(val) {
      return this.osg.codelabel('callResult', val);
    },
    formatMiddleCallResult(val) {
      return this.osg.codelabel('middleCallResult', val);
    },
    //上传头像图片文件转base64
    getFileToBase64(file) {
      var that = this;
      const isJPG = file.raw.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.osg.toast('上传头像图片只能是 JPG 格式！', 'error');
        return;
      }
      if (!isLt2M) {
        this.osg.toast('上传头像图片大小不能超过 2MB！', 'error');
        return;
      }
      this.$util.Base64.imgFile(file.raw).then(res => {
        if (res) {
          that.formData.avatar = res;
          that.$forceUpdate();
        } else {
          this.osg.toast('上传失败', 'error');
        }
      });
    },
    getData(callback) {
      this.osg.ajax('basic/contacts/queryById.do', { id: this.id }, res => {
        this.$util.renderExtField(this.extFields, res);
        this.formData = res;

        //获取关联的工单
        this.getServiceAppointmentData(null, this.id, () => {
          this.tabClick({ name: this.activeTab });
        });
        //获取关联的公司
        if (this.formData.companyIds && this.formData.companyIds.length > 0) {
          this.getCompanyData(null, this.formData.companyIds);
        }
        //获取关联的地址
        this.getAddressData();

        //线索
        this.getLead(this.id);

        if (callback) callback();
      });
    },
    doSave() {
      if (this.osg.validate()) {
        // 赋值省市区
        this.formData.area = this.formData.area || [];
        this.formData.province = this.formData.area[0] || '';
        this.formData.city = this.formData.area[1] || '';
        this.formData.district = this.formData.area[2] || '';

        this.$util.saveExtField(this.extFields, this.formData);
        //存经纬度用.的key来存值
        if (this.formData.gpsPoint) {
          this.$set(this.formData, 'gpsPoint.longitude', this.formData.gpsPoint.longitude);
          this.$set(this.formData, 'gpsPoint.latitude', this.formData.gpsPoint.latitude);
          delete this.formData.gpsPoint;
        }
        this.osg.ajax(
          'basic/contacts/upsertJson.do',
          { data: JSON.stringify(this.formData) },
          () => {
            this.osg.toast('保存成功！');
            this.getData();
          }
        );
      }
    },
    /**
     * 切换tab页
     */
    tabClick(tab) {
      switch (tab.name) {
        case 'purchase':
          this.$refs.purchase && this.$refs.purchase.clearSelection();
          this.purchase.selectedRows = [];
          this.purchaseQuery();
          break;
        case 'serviceAppointment':
          this.getServiceAppointmentFields(() => {
            this.getServiceAppointments();
          });
          break;
        case 'log':
          this.getLog();
          break;
        case 'notes':
          this.getNote();
          break;
        case 'record':
          this.getRecord();
          break;
        case 'callRecords':
          this.getCallRecords();
          break;
        case 'UDcallRecords':
          this.getUDCallRecords();
          break;
        case 'history':
          this.getHistory();
          break;
        default:
          return;
      }
    },
    /**
     * 日志
     */
    getLog() {
      this.log.searchDate = this.log.searchDate || [];
      // let sidList = this.serviceAppointment.relatedData.map(item => item._id);
      // if (Array.isArray(sidList) && sidList.length) {
      this.osg.ajax(
        'tenantLog/query.do',
        {
          // sid: this.id,
          // sid: sidList,
          // 'in:sid|Array#and': sidList.join(','),
          //  smodule: 'contact',
          // smodule: 'serviceAppointment',

          sid: this.id,
          smodule: 'contacts',
          _all: '1',
          'regex:title|string#or': this.log.searchValue,
          'regex:content|string#or': this.log.searchValue,
          'gte:createTime|datetime#and': this.log.searchDate[0],
          'lte:createTime|datetime#and': this.log.searchDate[1],
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          this.log.fpi = res;
        },
        { noload: true }
      );
      // }
    },
    /**
     * 笔记
     */
    getNote() {
      this.osg.ajax(
        'note/query.do',
        {
          sid: this.id,
          smodule: 'contacts',
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          this.noteData = res || [];
        }
      );
    },
    saveNote() {
      var params = {
        //sid，smodul，content，id，isDelete(值Y) 保存传123,修改传1234,删除传12345
        sid: this.id,
        smodule: 'contacts',
        content: this.vqeditor.content
      };
      this.osg.ajax('note/upsert.do', params, () => {
        this.osg.toast('保存成功！');
        this.openNote = false;
        this.getNote();
      });
    },
    //合同列表
    getContract() {
      this.osg.ajax(
        'basic/contacts/queryContractById.do',
        {
          // _all: '1',
          id: this.id
          // 'in:state|array-integer#and': '0,1',
          // sortField: 'updateTime',
          // sortOrder: 'asc'
        },
        res => {
          this.contractList = res.data;
        }
      );
    },
    //获取优惠券记录
    getCouponPrintings() {
      let userId = this.formData.userId;
      if (!userId) return;
      var params = {
        _all: '1',
        sortField: 'createTime',
        sortOrder: 'desc',
        'is:userId|string#and': userId
      };
      this.osg.ajax('basic/couponPrinting/query.do', params, res => {
        this.couponPrinting.relatedData = res.data;
      });
    },
    //质保列表
    getWarranty() {
      // var params = {
      //   _all: '1',
      //   sortField: 'updateTime',
      //   sortOrder: 'asc'
      //   // sortField: 'createTime',
      //   // sortOrder: 'desc'
      // };
      this.osg.ajax(
        'basic/contacts/queryInsurancePolicyById.do',
        {
          id: this.id
          // _all: '1',
          // 'in:state|array-integer#and': '0,1',
          // sortField: 'updateTime',
          // sortOrder: 'asc'
        },
        res => {
          this.warrantyList = res.data;
        }
      );
    },
    noteMdShow(note) {
      note.openNote = true;
    },
    /**
     * 通话记录
     */
    getCallRecords() {
      this.callRecords.searchDate = this.callRecords.searchDate || [];
      this.osg.ajax(
        'basic/sobot/query.do',
        {
          contactsId: this.id
          // bizId: this.id,
          // bizType: 'Contacts',
          // _all: '1',
          // 'regex:callerName|string#or': this.callRecords.searchValue,
          // 'regex:caller|string#or': this.callRecords.searchValue,
          // 'regex:callee|string#or': this.callRecords.searchValue,
          // 'gte:createTime|datetime#and': this.callRecords.searchDate[0],
          // 'lte:createTime|datetime#and': this.callRecords.searchDate[1],
          // sortField: 'createTime',
          // sortOrder: 'desc'
        },
        res => {
          // contactsId
          this.callRecords.fpi = res;
        },
        { noload: true }
      );
    },
    /**
     * UD通话记录
     */

    getUDCallRecords() {
      // this.callRecords.searchDate = this.callRecords.searchDate || [];
      // var params = {};
      this.osg.ajax(
        'biz/ud/query.do',
        {
          // contactsId: this.id,
          // bizId: this.id,
          // bizType: 'ServiceAppointment',
          // _all: '1',
          // tenantId:'1340835581184723420',
          customer_number: this.formData.phone
          // serviceAppointmentId:this.id,
          // 'regex:callerName|string#or': this.callRecords.searchValue,
          // 'regex:caller|string#or': this.callRecords.searchValue,
          // 'regex:callee|string#or': this.callRecords.searchValue,
          // 'gte:createTime|datetime#and': this.callRecords.searchDate[0],
          // 'lte:createTime|datetime#and': this.callRecords.searchDate[1],
          // sortField: 'createTime',
          // sortOrder: 'desc'
        },
        res => {
          this.UDcallRecords.fpi = res;
        },
        { noload: true }
      );
    },
    /**
     * 操作记录
     */
    getHistory() {
      // 其他getFields查询会更新掉表单的fieldsObj
      let fieldsObj = {};
      this.extFields.map(item => {
        if (item.showList && item.showList.indexOf('6') != -1) {
          item.label = item.nameDisp;
          item.value = item.name;
          fieldsObj[item.name] = item;
        }
      });
      this.fieldsObj = fieldsObj;
      this.osg.ajax(
        'biz/changeLog/query.do',
        {
          sid: this.id,
          page: this.historyFpi.page,
          rows: (this.historyFpi.rows += 10)
        },
        res => {
          if (res) {
            if (res.data.length > 0) {
              // 不需要展示变更的字段名
              res.data.filter(item => {
                item.modifyList = item.modifyList.filter(obj => {
                  return (
                    this.fieldsObj[obj.field] &&
                    this.fieldsObj[obj.field].showList.indexOf('6') != -1
                  );
                });
                return item.modifyList.length > 0;
              });
              this.historyFpi = res;
            }
          }
        },
        { noload: true }
      );
    },
    getFields() {
      this.osg.ajax(
        'biz/ext/queryByColName/contacts.do',
        {
          _all: 1
        },
        res => {
          if (res.entity) {
            this.fields = res.entity.extFieldList;

            let fieldsObj = {};
            res.entity.extFieldList.map(item => {
              item.label = item.nameDisp;
              item.value = item.name;
              fieldsObj[item.name] = item;

              if (this.$util.isJson(item.frontEndConfig)) {
                item.frontEndConfig = JSON.parse(item.frontEndConfig);
              } else {
                item.frontEndConfig = {};
              }
              // 扩展字段支持配置是否不展示字段修改记录
              if (item.frontEndConfig.historyHide || item.type == 'file') {
                this.historyHide.push(item.name);
              }
            });
            this.options.fields = res.entity.extFieldList;
            this.fieldsObj = fieldsObj;
          }
        },
        {
          noload: true
        }
      );
    },
    formatField(row, column, cellValue) {
      return this.osg.codelabel('fields', cellValue);
    },
    formatFieldValue(row, field, cellValue) {
      if (cellValue) {
        if (this.$util.isJson(cellValue)) {
          cellValue = JSON.parse(cellValue);
        }
      }
      if (field && field.valueOption) {
        if (field.type == 'cascade') {
          if (field.frontEndConfig.multiple) {
            return this.osg.formatCascadeMultiple(field.valueOption, cellValue);
          } else {
            return this.osg.formatCascade(field.valueOption, cellValue);
          }
        } else {
          return this.osg.codelabel(field.valueOption, cellValue);
        }
      } else if (row.field == 'area' || (field && field.type == 'area')) {
        return this.formatArea(cellValue);
      } else {
        return cellValue;
      }
    },
    // 关联公司
    newCompany() {
      this.company.openRelate = true;
      this.getCompanyData();
    },
    editCompany(item) {
      this.company.formData = item;
      this.company.openEdit = true;
    },
    getCompanyData(query, companyIds) {
      var params = {
        page: 1,
        _all: '1',
        'regex:name|string#or': query,
        'in:_id|array#and': companyIds && companyIds.join(','),
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      this.osg.ajax(
        'basic/company/query.do',
        params,
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          if (companyIds) {
            this.company.relatedData = res.data;
          } else {
            this.company.data = res.data;
          }
          this.$forceUpdate();
        },
        { noload: true }
      );
    },
    saveCompany() {
      if (this.osg.validate('companyFormData')) {
        this.osg.ajax('basic/company/upsert.do', this.company.formData, res => {
          //将新创建的公司id保存到客户的companyIds字段
          if (this.formData.companyIds.indexOf(res.data._id) == -1) {
            this.formData.companyIds.push(res.data._id);
            this.doSave();
          }
          this.getData();
        });
      }
    },
    removeCompany(item) {
      this.osg.confirm(`删除与 "${item.name}" 的关联？`, () => {
        var companyIds = this.formData.companyIds;
        for (let i = 0; i < companyIds.length; i++) {
          if (item._id == companyIds[i]) {
            companyIds.splice(i, 1);
            this.doSave();
            return;
          }
        }
      });
    },
    initCompany() {
      this.company.openEdit = false;
      this.company.openRelate = false;
      this.company.formData = {};
      this.$refs['companyFormData'].resetFields();
    },
    getServiceAppointmentFields(callback) {
      this.osg.getFields(
        'serviceAppointment',
        () => {
          if (callback) callback();
        },
        this,
        'serviceAppointment.extFields'
      );
    },
    getServiceAppointments() {
      this.osg.ajax(
        'basic/serviceAppointment/query.do',
        {
          page: this.serviceAppointment.fpi.page,
          rows: this.serviceAppointment.fpi.rows,
          notFilterBelongTo: '1',
          notFilterOrgId: '1',
          'is:state|integer#and': 1,
          'in:contactIds|string#and': this.formData._id,
          'regex:title|string#or': this.serviceAppointment.searchValue,
          'regex:orderNum|string#or': this.serviceAppointment.searchValue,
          'regex:name|string#or': this.serviceAppointment.searchValue,
          'regex:phone|string#or': this.serviceAppointment.searchValue,
          'regex:address|string#or': this.serviceAppointment.searchValue,
          'regex:exts.newAddress|string#or': this.serviceAppointment.searchValue
        },
        res => {
          this.serviceAppointment.fpi = res;
          this.$refs.serviceAppointment && this.$refs.serviceAppointment.doLayout();
        }
      );
    },
    // 关联工单
    newServiceAppointment() {
      this.serviceAppointment.openRelate = true;
      this.getServiceAppointmentData();
    },
    editServiceAppointment(item) {
      var area = [];
      if (item.province) {
        area[0] = item.province;
      }
      if (item.city) {
        area[1] = item.city;
      }
      if (item.district) {
        area[2] = item.district;
      }
      item.area = area;
      this.serviceAppointment.formData = item;
      this.serviceAppointment.openEdit = true;
    },
    getServiceAppointmentData(query, contactId, callback) {
      var params = {
        _all: '1',
        sortField: 'createTime',
        sortOrder: 'desc',
        'regex:name|string#or': query,
        'regex:title|string#or': query,
        'all:contactIds|string#and': contactId,
        'is:state|integer#and': 1
      };
      //搜索关联（全部工单），不返回已关联的工单
      if (!contactId) {
        params['nin:contactIds|string#and'] = this.id;
      }
      this.osg.ajax(
        'basic/serviceAppointment/query.do',
        params,
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          if (contactId) {
            this.serviceAppointment.relatedData = res.data;
          } else {
            this.serviceAppointment.data = res.data;
          }
          if (callback) callback();
          this.$forceUpdate();
        },
        { noload: true }
      );
    },
    saveServiceAppointment(type) {
      //搜索关联
      if (type == 'search') {
        this.serviceAppointment.searchObj.contactIds.push(this.id);
        var obj = this.serviceAppointment.searchObj;
        obj.area = obj.area || [];
        obj.province = obj.area[0] || '';
        obj.city = obj.area[1] || '';
        obj.district = obj.area[2] || '';
        this.osg.ajax('basic/serviceAppointment/upsert.do', { data: JSON.stringify(obj) }, () => {
          this.getData();
        });
        this.initServiceAppointment();
      } else {
        this.serviceAppointment.formData.contactIds =
          this.serviceAppointment.formData.contactIds || [];
        if (this.serviceAppointment.formData.contactIds.indexOf(this.id) == -1) {
          //新建 将新客户id保存到工单contactIds字段
          this.serviceAppointment.formData.contactIds.push(this.id);
        } // else即编辑
        obj = this.serviceAppointment.formData;
        obj.area = obj.area || [];
        if (obj.area.length > 0) {
          obj.province = obj.area[0] || '';
          if (obj.area.length > 1) {
            obj.city = obj.area[1] || '';
            if (obj.area.length > 2) {
              obj.district = obj.area[2] || '';
            }
          }
        }
        if (this.osg.validate('serviceAppointmentFormData')) {
          this.osg.ajax(
            'basic/serviceAppointment/upsert.do',
            {
              data: JSON.stringify(this.serviceAppointment.formData)
            },
            () => {
              this.getData();
            }
          );
          this.initServiceAppointment();
        }
      }
    },
    removeServiceAppointment(item) {
      this.osg.confirm(`删除与 "${item.title}" 的关联？`, () => {
        var contactIds = item.contactIds;
        for (let i = 0; i < contactIds.length; i++) {
          if (this.id == contactIds[i]) {
            contactIds.splice(i, 1);
            //更新工单contactIds字段，删除当前客户id
            this.osg.ajax(
              'basic/serviceAppointment/upsert.do',
              { data: JSON.stringify(item) },
              () => {
                this.getServiceAppointmentData(null, this.id);
              }
            );
            return;
          }
        }
      });
    },
    initServiceAppointment() {
      this.serviceAppointment.searchObj = {};
      this.serviceAppointment.openEdit = false;
      this.serviceAppointment.openRelate = false;
      this.serviceAppointment.formData = {};
      this.serviceAppointment.activeName = 'search';
      this.$refs['serviceAppointmentFormData'].resetFields();
    },
    initLead() {
      this.lead.searchObj = {};
      this.lead.openEdit = false;
      this.lead.openRelate = false;
      this.lead.formData = {};
      this.lead.activeName = 'create';
      this.$refs['leadFormData'].resetFields();
      this.getLead(this.id);
    },
    saveLead() {
      // //将的客户id保存到新创建的线索的contactsIds字段
      // this.lead.formData.contactsId = this.lead.formData.contactsId || [];
      this.lead.formData.contactsId = this.id;
      if (this.osg.validate('leadFormData')) {
        //存经纬度用.的key来存值
        if (this.lead.formData.gpsPoint) {
          this.$set(
            this.lead.formData,
            'gpsPoint.longitude',
            this.lead.formData.gpsPoint.longitude
          );
          this.$set(this.lead.formData, 'gpsPoint.latitude', this.lead.formData.gpsPoint.latitude);
          delete this.lead.formData.gpsPoint;
        }
        this.osg.ajax('basic/lead/upsert.do', this.lead.formData, () => {
          this.osg.toast('操作成功！');
          this.initLead();
        });
      }
    },
    //关联地址
    newAddress() {
      this.address.openEdit = true;
    },
    newLead() {
      this.lead.openRelate = true;
    },
    editAddress(item) {
      var area = [];
      if (item.province) {
        area[0] = item.province;
      }
      if (item.city) {
        area[1] = item.city;
      }
      if (item.district) {
        area[2] = item.district;
      }
      item.area = area;
      this.address.formData = item;
      this.address.openEdit = true;
    },
    //拨打电话回调，将callid存储，如果要记录跟进记录，存储到跟进记录对象上
    callOutBack(data) {
      if (data) {
        this.callId = data.callId;
        this.activeTab = 'record';
        // this.record.openRecord = true;

        this.$emit('objectDataFn', {
          exhaleOpen: true, //打开呼出
          bizId: this.formData._id,
          bizType: 'Contacts',
          callId: data.callId,
          caller: this.formData.phone,
          formData: this.formData,
          extFields: this.extFields,
          SAextFields: this.SAextFields,
          options: this.options
        });
      }
    },
    //保存跟进记录ajax
    saveRecordAjax(data, callback) {
      //跟进记录需要前端生成_id
      data._id = data._id ? data._id : this.randomUUid();
      let params = {
        bizType: 'Contacts',
        bizId: this.id,
        callId: this.callId
      };
      params = Object.assign(params, data);
      this.osg.ajax('followingUpNote/upsert.do', params, () => {
        this.getRecord();
        this.record.openRecord = false;
        this.record.openLiteRecord = false;
        this.callId = '';
        if (callback) callback();
      });
    },
    //打开跟进记录弹窗
    openRecordFun() {
      this.record.recordFormData = {
        exts: {},
        gpsPoint: {}
      };
      // this.record.SArecordFormData = { gpsPoint: {}, exts: {} };
      let contactData = this.$util.deepCopy(this.converTemp(this.formData));
      //防水的租户id
      if (this.tenantId == '1340835581184723420') {
        contactData.area =
          contactData.area && Array.isArray(contactData.area) && contactData.area.length == '3'
            ? contactData.area
            : null;
        contactData.channel =
          contactData.channel &&
          Array.isArray(contactData.channel) &&
          contactData.channel.length == '3'
            ? contactData.channel
            : null;
      } else {
        this.record.openLiteRecord = true;
        return;
      }
      this.record.SArecordFormData = contactData;
      this.osg.getSubdistricts(this.record.SArecordFormData.area, result => {
        this.options.subdistricts2 = result;
        this.$forceUpdate();
      });
      this.$set(
        this.record.SArecordFormData,
        'title',
        this.record.SArecordFormData.name + '的工单' + this.$util.readableTime()
      );
      // this.$util.renderExtField(this.extFields, this.record.SArecordFormData);
      this.record.openRecord = true;
    },
    //发送短信
    sendMessages() {
      this.osg.confirm(`确定给 "${this.formData.name}" 发送该条短信吗？`, () => {
        this.osg.ajax(
          '/basic/sms/sendMessage.do',
          {
            bizType: 'Contacts',
            bizId: this.id,
            phone: this.formData.phone,
            content: this.messagesContent
          },
          res => {
            this.osg.toast(res.message, res.success ? '' : 'error');
            this.messagesContent = '';
            this.openMessages = false;
          }
        );
      });
    },
    editLead(item) {
      var area = [];
      if (item.province) {
        area[0] = item.province;
      }
      if (item.city) {
        area[1] = item.city;
      }
      if (item.district) {
        area[2] = item.district;
      }
      item.area = area;
      this.lead.formData = item;
      this.lead.openEdit = true;
    },
    getAddressData() {
      var params = {
        page: 1,
        rows: 10,
        'eq:typeId|string#or': this.id,
        sortField: 'createTime',
        sortOrder: 'desc',
        _all: '1'
      };
      this.osg.ajax(
        'basic/address/query.do',
        params,
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.address.relatedData = res.data;
        },
        { noload: true }
      );
    },
    getLead(/*contactsIds*/) {
      if (!this.id) return;
      var params = {
        page: 2,
        rows: 10,
        // 'in:_id|array#and': contactsIds.join(),
        // 'in:contactsIds|string#and': this._id,
        'is:contactsId|string#and': this.id,
        sortField: 'createTime',
        sortOrder: 'desc',
        _all: '1'
      };
      this.osg.ajax(
        'basic/lead/query.do',
        params,
        res => {
          // if (contactsIds && contactsIds.length > 0) {
          //   this.lead.relatedData = res.data;
          // } else {
          //   this.lead.data = res.data;
          //   if (this.lead && !this.lead.length) this.lead.relatedData = [];
          // }
          if (this.id) {
            this.lead.relatedData = res.data;
            console.log(this.lead.relatedData);
          } else {
            this.lead.data = res.data;
            // if (this.lead && !this.lead.length) this.lead.relatedData = [];
          }
        },
        { noload: true }
      );
    },
    saveAddress() {
      if (this.osg.validate('addressFormData')) {
        var obj = this.address.formData;
        obj.area = obj.area || [];
        obj.province = obj.area[0] || '';
        obj.city = obj.area[1] || '';
        obj.district = obj.area[2] || '';
        this.address.formData.typeId = this.id;
        this.osg.ajax('basic/address/upsert.do', this.address.formData, () => {
          this.getAddressData();
          this.initAddress();
        });
      }
    },
    removeAddress(item) {
      this.osg.confirm(`删除与 "${item.address}" 的关联？`, () => {
        item.typeId = '';
        this.osg.ajax('basic/address/upsert.do', item, () => {
          this.getAddressData();
          this.initAddress();
        });
      });
    },
    removeLead(item) {
      let row = item;
      this.osg.confirm(`删除与 "${row.name}" 的关联？`, () => {
        // row.contactsIds.splice(row.contactsIds.indexOf, 1);
        row.contactsId = '';
        //存经纬度用.的key来存值
        if (row.gpsPoint) {
          this.$set(row, 'gpsPoint.longitude', row.gpsPoint.longitude);
          this.$set(row, 'gpsPoint.latitude', row.gpsPoint.latitude);
          delete row.gpsPoint;
        }
        this.osg.ajax('basic/lead/upsert.do', row, () => {
          this.getLead(this.id);
          this.initLead();
        });
      });
    },
    initAddress() {
      this.address.openEdit = false;
      this.address.formData = {};
      this.$refs['addressFormData'].resetFields();
    },
    /**
     * 外呼
     */
    callOut() {
      // 调用外呼接口-传外呼号码
      this.osg.sobot.callOut({
        destinationNumber: this.formData.phone,
        params: `{ "bizType":"Contacts","bizId":"${this.formData._id}"}`
      });
      // 打开笔记
      this.activeTab = 'notes';
      this.openNote = true;
    },
    //获取跟进记录
    getRecord() {
      var params = {
        _all: '1',
        sortField: 'createTime',
        sortOrder: 'desc',
        bizType: 'Contacts',
        bizId: this.id
      };
      this.osg.ajax(
        'followingUpNote/query.do',
        params,
        res => {
          if (res.data) {
            this.record.fpi = res;
          }
        },
        {
          noload: true
        }
      );
    },
    //查看通话记录
    viewCallRecord(callId) {
      this.osg.ajax(
        'basic/sobot/queryByCallId.do',
        {
          callId
        },
        res => {
          if (res.data) {
            this.record.callData = res.data;
            this.record.openCallRecord = true;
          }
        },
        { noload: true }
      );
    },
    //保存跟进记录确定按钮
    saveRecord(state) {
      //保存状态，生成跟进记录
      if (state == 0) {
        if (this.osg.validate('recordFormData')) {
          this.saveRecordAjax(this.record.recordFormData, () => {
            this.osg.toast('保存成功！');
            this.getData();
          });
          this.record.recordFormData = {
            exts: {},
            gpsPoint: {}
          };
          this.record.SArecordFormData = {};
        }
      } else if (state == 1) {
        //生成跟进记录并建单
        let SArecordFormData = this.$util.deepCopy(this.record.SArecordFormData);
        if (this.osg.validate('recordFormData') && this.osg.validate('SArecordFormData')) {
          const UUID = this.randomUUid();
          //将客户id关联工单
          SArecordFormData.contactIds = SArecordFormData.contactIds || [];
          if (SArecordFormData.contactIds.indexOf(this.id) == -1) {
            //将客户id保存到工单contactIds字段
            SArecordFormData.contactIds.push(this.id);
          }
          //TODO: 工单扩展字段存储与跟进记录相同的id
          this.record.recordFormData._id = UUID;
          //跟进记录对象赋值表单字段
          if (SArecordFormData.area.length > 0) {
            SArecordFormData.province = SArecordFormData.area[0] || '';
            if (SArecordFormData.area.length > 1) {
              SArecordFormData.city = SArecordFormData.area[1] || '';
              if (SArecordFormData.area.length > 2) {
                SArecordFormData.district = SArecordFormData.area[2] || '';
              }
            }
          }
          this.record.recordFormData.name = SArecordFormData.name;
          this.record.recordFormData.phone = SArecordFormData.phone;
          this.record.recordFormData.province = SArecordFormData.province;
          this.record.recordFormData.city = SArecordFormData.city;
          this.record.recordFormData.district = SArecordFormData.district;
          this.record.recordFormData.address = SArecordFormData.address;
          this.record.recordFormData.channel = SArecordFormData.channel;
          this.record.recordFormData.leakagesite = JSON.stringify(
            SArecordFormData.exts.leakagesite
          );
          this.saveRecordAjax(this.record.recordFormData, () => {
            //TODO: 工单扩展字段存储与跟进记录相同的id
            SArecordFormData.exts.followingUpNoteId = this.record.recordFormData._id;
            this.doSaveSA(SArecordFormData, SAData => {
              //给客户赋上与工单id
              let SAId = SAData._id;
              if (!this.formData.serviceAppointIds) this.formData.serviceAppointIds = [];
              if (this.formData.serviceAppointIds.indexOf(SAId) == -1) {
                if (Array.isArray(this.formData.serviceAppointIds)) {
                  this.formData.serviceAppointIds.push(SAId);
                } else {
                  this.formData.serviceAppointIds = [SAId];
                }
              }
            });
            this.record.recordFormData = {
              exts: {},
              gpsPoint: {}
            };
            this.record.SArecordFormData = {};
            this.doSave();
          });
        }
      }
    },
    //生成uuid（18位），随机数（5位）+时间戳（13位）
    randomUUid() {
      let num = '';
      for (var i = 0; i < 5; i++) {
        num += Math.floor(Math.random() * 10);
      }
      return num + new Date().valueOf();
    },
    //用于扩展字段，判断如果配置了因为某个字段值才显示
    isShowField(obj, key, showField, showValue) {
      if (
        obj[showField] &&
        (obj[showField] == showValue || Array.isArray(obj[showField])
          ? obj[showField].flat().indexOf(showValue) !== -1
          : obj[showField].indexOf(showValue) !== -1)
      )
        return true;

      obj.exts = obj.exts || {};
      if (
        obj.exts[showField] &&
        (obj.exts[showField] == showValue || Array.isArray(obj.exts[showField])
          ? obj.exts[showField].flat().indexOf(showValue) !== -1
          : obj.exts[showField].indexOf(showValue) !== -1)
      )
        return true;
    },
    //接受参数生成工单
    doSaveSA(params, callback) {
      if (!params) return;
      params.area = params.area || [];
      if (params.area.length > 0) {
        params.province = params.area[0] || '';
        if (params.area.length > 1) {
          params.city = params.area[1] || '';
          if (params.area.length > 2) {
            params.district = params.area[2] || '';
          }
        }
      }
      // this.$util.saveExtField(this.SAextFields, params);
      // 自定义字段转换值
      this.$util.saveFormatExtField(this.SAextFields, params);
      this.osg.ajax(
        'basic/serviceAppointment/upsert.do',
        { data: JSON.stringify(params) },
        res => {
          // this.osg.toast('操作成功！');
          if (callback) callback(res.entity);
          this.getServiceAppointmentData(null, this.id);
        },
        { noload: true }
      );
    },
    //选择客户
    handleSelect(item) {
      let contactIds = this.record.SArecordFormData.contactIds || [];
      contactIds.push(item._id);
      this.$set(this.record.SArecordFormData, 'contactIds', contactIds);
      this.$set(this.record.SArecordFormData, 'phone', item.phone);
      this.$set(this.record.SArecordFormData, 'address', item.address);
    },
    //电话条-子组件传参
    phoneStripFn(data) {
      //弹屏
      this.$set(this.phoneStripData, 'phoneStripPopUp', data.phoneStripPopUp);
      //挂断
      // if (data.isHangUp === false) this.$set(this.record, 'openRecord', data.isHangUp);

      // 确定转移
      if (data.isConfirmTransfer === false)
        this.$set(this.record, 'openRecord', data.isConfirmTransfer);

      //转移并请求分页列表
      this.$set(this.phoneStripData, 'isTransfer', data.isTransfer);
      if (this.phoneStripData.isTransfer) this.getCorrespondent();
      console.log(this.phoneStripData);
    },
    //转客服按钮
    transferHandle(row) {
      this.storagetransfer = row;
      this.osg.confirm(`确定转移给"${row.name}" 吗？`, () => {
        this.osg.ajax(
          'basic/sobot/handleAgentTransfer.do',
          {
            bizType: 'contacts',
            bizId: this.id,
            userId: row._id,
            callId: this.callId,
            callWay: row.callWay
          },
          () => {
            this.osg.toast('转移成功！');
          }
        );
      });
    },
    //请求客服列表（当前空闲的客服）
    getCorrespondent() {
      let params = {
        // 'is:state|integer#and': 1,
        sortField: 'createTime',
        sortOrder: 'asc',
        bizId: this.formData._id,
        bizType: 'Contacts',
        callId: this.callId,
        caller: this.formData.phone
      };
      this.osg.ajax('basic/sobot/usableAgentTransferList.do', params, res => {
        this.correspondentList = res.data;
        this.$nextTick(() => {
          this.$refs.correspondentTable.doLayout();
          this.$forceUpdate();
        });
      });
    },
    getSAextFields() {
      this.osg.ajax(
        'biz/extField/query.do',
        {
          colName: 'serviceAppointment',
          _all: '1',
          'is:state|integer#and': 1,
          'nin:preset|array-integer#and': 1,
          sortField: 'order',
          sortOrder: 'asc'
        },
        res => {
          this.SAextFields = res.data;
          for (var item of res.data) {
            if (this.$util.isJson(item.frontEndConfig)) {
              item.frontEndConfig = JSON.parse(item.frontEndConfig);
            } else {
              item.frontEndConfig = {};
            }
            if (item.valueOption)
              this.options['codecfg_' + item.valueOption] = {
                codeId: item.valueOption
              };
            //级联
            if (item.type == 'cascade')
              this.options['cascadeCode_' + item.valueOption] = {
                codeId: item.valueOption
              };
          }
          this.osg.codeoption(() => {});
        },
        { noload: true }
      );
    },
    //反显字典表，支持类型传数组
    codelabelFilter(value, ops) {
      if (Array.isArray(value)) {
        let result = '';
        for (let item of value) {
          result += ' ' + this.osg.codelabel(ops, item);
        }
        return result;
      } else {
        return this.osg.codelabel(ops, value);
      }
    },
    formatterCodelabel(cellValue, valueOption, type) {
      if (
        (type == 'cascade' && cellValue && cellValue.indexOf(',') != -1) ||
        Array.isArray(cellValue)
      ) {
        let value = Array.isArray(cellValue) ? cellValue : cellValue.split(',');
        if (Array.isArray(value)) {
          let result = '';
          for (let item of value) {
            result += this.orderCodelabel(valueOption, item) + '-';
          }
          return result.substring(0, result.length - 1); //删除最后字符
        }
      } else if (type == 'cascade' && valueOption) {
        return this.orderCodelabel(valueOption, cellValue);
      } else {
        return cellValue;
      }
    },
    orderCodelabel: function(codeType, codeValue) {
      var opts = this.options[codeType];
      opts = this.cascadeFlat(opts);
      if (opts) {
        for (var i = 0; i < opts.length; i++) {
          if (codeValue == opts[i].value) return opts[i].name;
        }
      }
      if (!codeValue) {
        return codeValue;
      } else {
        return '未知';
      }
    },
    cascadeFlat: function(source) {
      if (Array.isArray(source)) {
        let flatArr = [];
        let fn = function(source) {
          source.forEach(el => {
            flatArr.push(el);
            if (el.children && el.children.length > 0) fn(el.children);
          });
        };
        fn(source);
        return flatArr;
      } else {
        return source;
      }
    },
    //反显服务步骤省市区
    formatArea(arr) {
      if (!arr) return;
      let str = '';
      if (arr[0]) str += this.osg.areaObj.province_list[arr[0]];
      if (arr[1]) str += this.osg.areaObj.city_list[arr[1]];
      if (arr[2]) str += this.osg.areaObj.county_list[arr[2]];
      return str;
    },
    formatProvince(cellValue) {
      if (!cellValue) return '';
      return this.osg.areaObj.province_list[cellValue];
    },
    formatCity(cellValue) {
      if (!cellValue) return '';
      return this.osg.areaObj.city_list[cellValue];
    },
    formatDistrict(cellValue) {
      if (!cellValue) return '';
      return this.osg.areaObj.county_list[cellValue];
    },
    //根据网址 提示域名下拉框
    querySearch(queryString, cb) {
      let url = this.company.formData.website;
      let reg = /^((https|http|ftp|rtsp|mms){0,1}(:\/\/){0,1})www\.(([A-Za-z0-9-~]+)\.)+([A-Za-z0-9-~/])+$/;
      if (reg.test(url)) {
        if (url.indexOf('www.') != -1) {
          url = url.substr(url.indexOf('.') + 1);
        } else if (url.indexOf('http://') != -1) {
          url = url.substr(url.indexOf('/', url.indexOf('/') + 1) + 1);
        } else if (url.indexOf('https://') != -1) {
          url = url.substr(url.indexOf('/', url.indexOf('/') + 1) + 1);
          if (url.indexOf('https://www.') != -1) {
            url = url.substr(url.indexOf('.') + 1);
          }
        }
        // 调用 callback 返回建议列表的数据
        cb([{ label: url, value: url }]);
      } else {
        cb([{}]);
      }
    },
    purchaseFieldsQuery(callback) {
      this.osg.getFields(
        'purchase',
        () => {
          if (callback) callback();
        },
        this,
        'purchase.extFields'
      );
    },
    purchaseQuery() {
      this.purchase.searchDate = this.purchase.searchDate || [];
      this.osg.ajax(
        'biz/extForm/queryByColName/purchase.do',
        {
          contactId: this._id,
          sortField: 'createTime',
          sortOrder: 'asc',
          page: this.purchase.fpi.page,
          rows: this.purchase.fpi.rows,
          'is:state|integer#and': 1,
          'is:contactId|string#and': this.id,
          'gte:installDate|string#and': this.purchase.searchDate[0],
          'lte:installDate|string#and': this.purchase.searchDate[1],
          'regex:productName|string#or': this.purchase.searchValue,
          'regex:spec|string#or': this.purchase.searchValue,
          'regex:address|string#or': this.purchase.searchValue,
          'regex:orderNum|string#or': this.purchase.searchValue
        },
        res => {
          this.purchase.fpi = res;
          this.$nextTick(
            () => {
              this.$refs.purchase && this.$refs.purchase.doLayout();
            },
            {
              noload: true
            }
          );
        }
      );
    },
    purchaseNew() {
      this.purchase.formData = {};
      this.purchase.open = true;
      this.$nextTick(() => {
        this.$refs.purchaseFormData && this.$refs.purchaseFormData.clearValidate();
        this.$forceUpdate();
      });
    },
    purchaseEdit(row) {
      this.purchase.formData = this.$util.deepCopy(row);
      this.purchase.open = true;
    },
    purchaseSave() {
      if (this.osg.validate('purchaseFormData')) {
        this.purchase.formData.state = this.purchase.formData.state || 1;
        this.purchase.formData.contactId = this.id;
        this.osg.ajax(
          'biz/extForm/upsert/6948018894006013044.do',
          { dataStr: JSON.stringify(this.purchase.formData) },
          () => {
            this.purchase.formData = {};
            this.purchase.open = false;
            this.purchaseQuery();
          }
        );
      }
    },
    purchaseRemove(id) {
      this.osg.confirm('是否确认删除？', () => {
        this.osg.ajax(
          'biz/extForm/remove/6948018894006013044.do',
          {
            formDataId: id
          },
          () => {
            this.purchaseQuery();
            this.osg.toast('删除成功');
          }
        );
      });
    },
    purchaseSelectChange(rows) {
      this.purchase.selectedRows = rows;
    },
    /**
     * 建单
     */
    SAExtFieldsQuery() {
      this.osg.getFields('declaration', () => {}, this, 'SA.extFields');
    },
    SANew() {
      if (this.purchase.selectedRows.length == 0) {
        this.osg.confirm('您当前未选择存货，是否继续创建工单？', () => {
          this.SA.formData = {
            contactIds: [this.id],
            name: this.formData.name,
            phone: this.formData.phone,
            area: this.formData.area || [],
            address: this.formData.address,
            exts: {
              phoneList: this.formData.exts.phoneList
                ? this.$util.deepCopy(this.formData.exts.phoneList)
                : [],
              newAddress: this.formData.exts.newAddress,
              visitTime: [],
              purchaseIds: []
            }
          };
          this.SA.open = true;
        });
      } else {
        let str = '';
        let selectedRowIds = [];
        let newAddresses = [];
        this.purchase.selectedRows.map(item => {
          str += item.productName + '、';
          selectedRowIds.push(item._id);
          if (item.address) newAddresses.push(item.address);
        });
        str = str.substr(0, str.length - 1);
        this.osg.confirm('您当前已选择存货：' + str + '，是否确认创建工单？', () => {
          this.SA.formData = {
            contactIds: [this.id],
            name: this.formData.name,
            phone: this.formData.phone,
            area: this.formData.area || [],
            address: this.formData.address,
            exts: {
              phoneList: this.formData.exts.phoneList
                ? this.$util.deepCopy(this.formData.exts.phoneList)
                : [],
              newAddress: this.formData.exts.newAddress,
              visitTime: [],
              purchaseIds: selectedRowIds
            }
          };
          // 取安装地址作为工单的新送货地址
          if (newAddresses.length > 0)
            this.SA.formData.exts.newAddress = newAddresses[newAddresses.length - 1];
          this.SA.open = true;
        });
      }
    },
    SASave() {
      let params = this.SA.formData;
      // 处理省市区数据
      params.area = params.area || [];
      if (params.area.length > 0) {
        params.province = params.area[0] || '';
        if (params.area.length > 1) {
          params.city = params.area[1] || '';
          if (params.area.length > 2) {
            params.district = params.area[2] || '';
          }
        }
      }
      if (this.tenantId == '2530349872480957853') {
        let SAType = this.osg.codelabel('workflowDefId', params.exts.workflowDefId);
        params.title = `${params.name}${params.phone}的${SAType}`;
      }

      if (this.osg.validate('SAFormData')) {
        this.osg.ajax(
          'basic/serviceAppointment/upsert.do',
          {
            data: JSON.stringify(params)
          },
          () => {
            this.SA.open = false;
            this.osg.toast('建单成功');
            this.getServiceAppointmentData(null, this.id);
          }
        );
      }
    }
  },
  watch: {
    'company.activeName'() {
      if (this.company.activeName == 'create') this.getData();
    },
    'serviceAppointment.activeName'() {
      this.serviceAppointment.searchObj = {};
    },
    'record.SArecordFormData'() {
      if (!this.record.SArecordFormData.gpsPoint) {
        this.record.SArecordFormData.gpsPoint = {};
      }
      if (!this.record.SArecordFormData.exts) {
        this.record.SArecordFormData.exts = {};
      }
    },

    //area 级联组件点击label就消失
    'formData.area'() {
      if (this.$refs.areaSelector) {
        this.$refs.areaSelector.dropDownVisible = false; //监听值发生变化就关闭它
      }
    },
    'serviceAppointment.formData.area'() {
      if (this.$refs.areaSelectorSA) {
        this.$refs.areaSelectorSAF.dropDownVisible = false; //监听值发生变化就关闭它
      }
    },
    'record.SArecordFormData.area'() {
      if (this.$refs.areaSelectorRSA) {
        this.$refs.areaSelectorRSA.dropDownVisible = false; //监听值发生变化就关闭它
      }
    },
    //综合跟进表单，通话状态
    'record.recordFormData.dedicateMode'() {
      if (this.$refs.cascaderRRdedicateMode) {
        this.$refs.cascaderRRdedicateMode.dropDownVisible = false; //监听值发生变化就关闭它
      }
    },
    //综合跟进表单，信息渠道
    'record.SArecordFormData.channel'() {
      if (this.$refs.cascaderRRchannel) {
        this.$refs.cascaderRRchannel.dropDownVisible = false; //监听值发生变化就关闭它
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.box-left {
  width: 280px !important;
  max-width: 280px !important;
  min-width: 280px !important;
}
.box-right {
  width: 280px !important;
  max-width: 280px !important;
  min-width: 280px !important;
}
/*个人信息*/
.box-left-header-contact {
  border-bottom: 1px solid #dfe3eb;
}
.profile-info {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.profile-info > * {
  margin: 10px auto;
}
.profile-info > span {
  margin: 0;
  font-weight: 400;
  font-size: 24px;
}
.profile-info ul {
  display: flex;
}
.profile-info ul li {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 5px;
}
.profile-info ul li span:last-child {
  margin-top: 8px;
  font-size: 12px;
}
/* 快捷按钮 */
.shortcuts button {
  background-color: #eaf0f6;
  border-color: #cbd6e2;
  color: #506e91;
}
.shortcuts button i {
  font-weight: bold;
}
</style>
